/*import AirDatepicker from 'air-datepicker';*/
import AirDatepicker from "../lib/air-datepicker/dist/air-datepicker";
import "../lib/air-datepicker/dist/air-datepicker.css";
import localeDe from '../lib/air-datepicker/dist/locale/de';

import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { LocaleContext, LoginContext, NavigateLockContext, OverlayContext, ScrollContext, StateContext } from './App';
import './Common.css';
import {useContext, useEffect, useLayoutEffect, useRef, useState} from 'react'; 
import { AvailabilityByPhone, LoadState, Location, MediationStatus, UploadInputState, UserType } from './enums.mjs';
import { checkMinMaxDate, checkUtfString, convertIsoToLocalIsoWithoutTimezone, createNavigateSmartUrl, csrfToken, genId, getAgeStr, getManagementLogoPath, getMediationStatusNo, getUserStr, get_translation_objects, postWithCsrf, remToPixels, sanitizeStr, uploadFile } from './util';
import moment from 'moment';
import { createRef } from 'react';
import { LogContext, LogDisplay } from './LogDisplay';
import { useAutoLoad, useNavigateSmart } from './hooks';
import { maxFileSizeBytes, maxPhoneNoLength, maxSpecificAvailabilityByPhoneLength, tooltipDelayMs } from './globals.mjs';
import { validatePhoneNumber, validateSpecialCareText, validateSpecificAvailabilityByPhone } from './validate';
import { MatchInfoWrapper } from "./Wishes";
import { createPortal } from "react-dom";


export function HeaderBig(props) {
    const navigateLock = useContext(NavigateLockContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();

    function handleClick() {
        props.onClick ? props.onClick() : navigate("/");
    }

    return (
        <div id="header" className={props.management ? "header_management" : ""} onClick={(e) => navigateLock.handleLockProtectedClick(e, (e) => handleClick())}>
            <img className={props.management ? "mn_logo_big_management" : ""} src={props.management ?  getManagementLogoPath(login.userLocation) : "/customer/logo.svg"}></img>
        </div>
    );
}

export function HeaderSmall(props) {
    const navigateLock = useContext(NavigateLockContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();

    function handleClick() {
        props.onClick ? props.onClick() : navigate("/");
    }

    return (
        <div id="header_small" className={props.management ? "header_management" : ""} onClick={(e) => navigateLock.handleLockProtectedClick(e, (e) => handleClick())}>
            <img className={props.management ? "mn_logo_small_management" : "mn_logo_small"} src={props.management ? getManagementLogoPath(login.userLocation) : "/customer/logo.svg"}></img>
        </div>
    );
}

export function HeaderWithButton(props) {
    return(
        <div id="header_with_button" className={props.langSelection ? "header_with_button_with_lang" : ""}>
            {props.small ?
                <HeaderSmall onClick={props.onHeaderClick} management={props.management} />
            :
                <HeaderBig onClick={props.onHeaderClick} management={props.management} />
            }
            
            { !props.noBtn ? 
                <div ref={props.menuBtnRef}>
                    { 
                        props.closeBtn ?
                        <CloseButtonBig onClick={props.onClick}/>
                        : <BurgerButtonBig onClick={props.onClick}/>
                    }
                </div>
            :
                null
            }

            { props.langSelection ?
                <div className="header_with_btn_lang_select_box">
                    <LangSelection noMargin={true}/>
                </div>
            :
                null
            }

        </div>
    )
}

// If you want this element to also update on external value changes with value === "", use the following prop:
// updateBehaviour2={true}
export function TextInput(props) {
    const locale = useContext(LocaleContext);

    const inputRefInternal = useRef();
    let inputRef = inputRefInternal;
    if(props.inputRef) {
        inputRef = props.inputRef;
    }

    const changed = useRef(false);

    const [displayValue, setDisplayValue] = useState(props.value);
    const [errorTextDisplayed, setErrorTextDisplayed] = useState(false);
    const [focussed, setFocussed] = useState(false);

    const [errorTextInternal, setErrorTextInternal] = useState("");
    const [manualErrorTextInternal, setManualErrorTextInternal] = useState(null);

    const [type, setType] = useState(props.type ? props.type : "text");


    // FUNCTIONS:

    function validate(v) {
        let checkResult = inputRef.current.checkValidity();

        if(props.checker) {
            checkResult = props.checker(v);
        }

        return checkResult;
    }

    function validateInternal(v, updateErrorText=false) {
        if(props.maxLength && v.length > props.maxLength) {
            if(updateErrorText) {
                setErrorTextInternal(locale.msgs.ONLY_N_CHARS_ALLOWED_SHORT.replace("${{max_characters}}", props.maxLength).replace("${{characters}}", v.length));
            }
            return false; 
        }

        if(!checkUtfString(String(v))) {
            if(updateErrorText) {
                setErrorTextInternal(locale.msgs.UNSPPORTED_CHARS);
            }
            return false;
        }
        
        return true;
    }

    function handleKeyDown(e) {
        if(e.key == "Enter" && props.onEnter != undefined){
            props.onEnter();
        }
    }

    function updateErrorText(v) {
        if(!v || v === "" || validate(v)) {
            setErrorTextDisplayed(false);
        }
        else {
            setErrorTextDisplayed(true);
        }

        if(v && !validateInternal(v, true)) {
            
        }
        else {
            setErrorTextInternal("");
        }
    }

    function checkAndEmit(val) {

        /*let valid = false;

        if(props.validate != undefined) {
            valid = props.validate(val);
        }
        else {
            valid = e.target.checkValidity();
        }
        */

        // If the field is optional we want to return "" if the field is empty as this is not an error
        if(props.optional && val === "") {
            props.onChange("");
        }
        else {
            if(!validate(val) || !validateInternal(val)) {
                if(props.valToReturnOnError != undefined) {
                    val = props.valToReturnOnError;
                }
                else {
                    val = null; // Return null if the validation failed
                }
            }

            props.onChange(val);
        }
    }

    function handleChange(e) {
        changed.current = true;

        let v = e.target.value;

        if(props.onPreAdjust) {
            v = props.onPreAdjust(v);
        }

        checkAndEmit(v);
        setDisplayValue(v);

        // For autofill as the element won't be focussed and the blur event is not fired
        if(!focussed || (errorTextDisplayed && v !== "")) {
            updateErrorText(v);
        }

        setManualErrorTextInternal(null);
    }

    function handleFocus(e) {
        setFocussed(true);

        if(changed.current) {
            updateErrorText(e.target.value);
        }
    }

    function handleBlur(e) {
        setFocussed(false);

        if(changed.current) {
            updateErrorText(e.target.value);
        }

        setManualErrorTextInternal(props.manualErrorText);

        if(props.onBlur) {
            props.onBlur();
        }
    }

    function handleVisibilityClick() {
        if(type === "password") {
            setTypeFunc("text");
        }
        else if(type === "text") {
            setTypeFunc("password");
        }
    }

    function setTypeFunc(type) {
        setType(type);

        if(props.onTempTypeChange) {
            props.onTempTypeChange(type);
        }
    }


    // EFFECTS:

    useLayoutEffect(() => {
        checkAndEmit(inputRef.current.value);
    }, []);

    let deps = [props.value];

    if(props.updateBehaviour2)
    {
        deps.push(props.readOnly);
    }

    useLayoutEffect(() => {
        if(props.updateBehaviour2)
        {
            let v = props.value;

            // DO NOT set v to "" if props.value holds the error value!
            // Otherwise this field will be cleared automatically on errors (which also leads to the error message never being displayed)!
            // if(props.value === null || props.value === props.valToReturnOnError)
            // {
            //     v = "";
            // }

            setDisplayValue(v);
            updateErrorText(v);
        }
        else
        {
            if(props.value === undefined) {
                setDisplayValue("");
            }
            else if(props.value !== null) {
                setDisplayValue(props.value);

                if(props.value !== "") {
                    updateErrorText(props.value);
                }
            }
        }
    }, deps);

    useLayoutEffect(() => {
        updateErrorText(displayValue);
    }, [props.manualCheckTrigger]);

    useLayoutEffect(() => {
        if(errorTextDisplayed) {
            updateErrorText(displayValue);
        }
    }, [props.manualCheckTriggerOnlyErr]);

    useLayoutEffect(() => {
        if(props.tempType) {
            setType(props.tempType);
        }
    }, [props.tempType]);

    useLayoutEffect(() => {
        if(!focussed || props.alwaysShowManualErrorText) {
            setManualErrorTextInternal(props.manualErrorText);
        }
    }, [props.manualErrorText]);


    // RENDER:

    let autocomplete = "";

    if(props.autocomplete) {
        autocomplete = props.autocomplete;
    }
    
    return (
        <div className="text_input_box">
            <div className={"input_box" + (props.minimal ? " input_box_minimal" : "") + (props.readOnly ? "" : (focussed ? " input_box_focus" : "") )}>
                <input ref={inputRef} id={props.id ? props.id : autocomplete}
                        className={"input" + (props.minimal ? " input_minimal": "") + (props.type === "password" ? " input_password": "") +
                                (props.reducedInputWidth ? " input_reduced": "")}
                        type={type} name={props.name} placeholder=" "
                        value={displayValue} autoComplete={autocomplete}
                        onChange={handleChange} onKeyDown={handleKeyDown} onFocus={handleFocus} onBlur={handleBlur} pattern={props.pattern}
                        readOnly={props.readOnly}>
                </input>

                <div className={"input_name" +
                        (props.minimal ?
                            " input_name_minimal" :
                            (props.showPlaceholderIfNotEmpty == undefined || props.showPlaceholderIfNotEmpty ?
                                props.readOnly && displayValue === "" ?
                                    ""
                                :
                                    " text_input_name"
                            :
                                " text_input_name_hide")
                        )}>
                    {props.text}
                </div>

                { props.type === "password" ?
                    <div className="text_input_visibility_box" onClick={handleVisibilityClick}>
                        { type === "password" ?
                            <img className="text_input_visibility" src={focussed ? "/common/icon_visibility-on-pink.svg" : "/common/icon_visibility-on-grey.svg"} />
                        :
                            type === "text" ?
                                <img className="text_input_visibility" src={focussed ? "/common/icon_visibility-off-pink.svg" : "/common/icon_visibility-off-grey.svg"} />
                            :
                                null
                        }
                    </div>
                :
                    null
                }
            </div>

            { errorTextInternal !== "" ?
                <div className="text_error_small input_error_text">{errorTextInternal}</div>
            :
                errorTextDisplayed && props.errorText != undefined /*&& props.errorText != ""*/ ?
                    <div className="text_error_small input_error_text">{props.errorText}</div>
                :
                    manualErrorTextInternal ?
                        <div className="text_error_small input_error_text">{manualErrorTextInternal}</div>
                    :
                        null
            }

        </div>
    );
}

export function TextInputLoading(props) {
    return (
        <div className="text_input_loading">
            <TextInput {...props} />

            {props.loading ?
                <div className="loader text_input_loading_loader"></div>
            :
                null
            }
        </div>
    )
}

export const TelNoInput = ({minimal, readOnly, text, value, onChange}) => {
    function handleClick() {
        window.location.href = "tel:" + value;
    }

    return(
        <div className="tel_no_input">
            <TextInput minimal={minimal} readOnly={readOnly} text={text} value={value} onChange={onChange}
                    maxLength={maxPhoneNoLength}/>

            <div className="tel_no_input_btn_box">
                <img src="/common/icon_phone.svg" onClick={handleClick} />
            </div>
        </div>
    )
}

export const TelNoInputNew = ({value, onChange, showPlaceholderIfNotEmpty, readOnly}) => {
    const locale = useContext(LocaleContext);

    const lastValue = useRef(value);

    function handlePreAdjust(v) {
        // We want to remove all unsupported characters (e.g. to handle copy paste problem on MAC (copy from contacts))

        let vCleaned = "";

        for(let c of v) {
            if("0123456789+ ".includes(c)) {
                vCleaned += c;
            }
        }

        v = vCleaned;
        return v;
    }

    function handleChange(v) {
        onChange(v);
    }

    return(
        <TextInput type="tel" text={locale.msgs.TELEPHONE_NO} value={value}
                showPlaceholderIfNotEmpty={showPlaceholderIfNotEmpty}
                onChange={handleChange}
                onBlur={() => {}}
                autocomplete="tel"
                name="tel"
                errorText={locale.msgs.ENTER_VALID_PHONE_NO}
                checker={(value) => validatePhoneNumber(value)}
                maxLength={maxPhoneNoLength}
                onPreAdjust={handlePreAdjust}
                readOnly={readOnly}
        />
    )
}

export const SearchInput = ({value, onValueChange, loading}) => {
    const locale = useContext(LocaleContext);
    const [focussed, setFocussed] = useState(false);

    function handleFocus(e) {
        setFocussed(true);
    }

    function handleBlur(e) {
        setFocussed(false);
    }

    return (
         <div className={"input_box search_input_box" + (focussed ? " input_box_focus" : "")}>
            <input className={"input search_input"} type="text" placeholder={locale.msgs.SEARCH}
                    value={value} onChange={(e) => onValueChange(e)} onFocus={handleFocus} onBlur={handleBlur}
            ></input>

            <img className="search_input_img" src="/common/icon_search.svg"></img>

            {loading ?
                <div className="loader search_input_loader"></div>
            :
                null
            }
        </div>
    );
}

// The value is always as excepted / returned by the datetime input element. That means:
//   If time == false, the date value is expected / returned (onChange) in the format yyyy-mm-dd
//   If time == true, the value string is expected / returned (onChange) in the format ISO 8601 (always UTC)
// onChange is called with null if the current datetime is not valid.
export function DateInput(props) {
    const [pickerId, setPickerId] = useState(genId());

    const locale = useContext(LocaleContext);
    const scroll = useContext(ScrollContext);

    const btnRef = useRef();

    const datePickerRef = useRef();
    const datePickerEleRef = useRef();
    const datePickerBoxEleRef = useRef();
    const pickerShownRef = useRef();
    const lastPickerDatRef = useRef();

    const [pickerBoxHeight, setPickerBoxHeight] = useState(0);
    const [pickerBoxTransform, setPickerBoxTransform] = useState("");
    const [pickerBoxLeft, setPickerBoxLeft] = useState(false);
    const [scaleFactor, setScaleFactor] = useState(1.3);

    const inputRef = useRef();
    const [displayStr, setDisplayStr] = useState(props.value ? toDisplayDateFormat(props.value) : "");
    const [focussed, setFocussed] = useState(false);
    const [errorText, setErrorText] = useState(null);

    const [manualErrorTextInternal, setManualErrorTextInternal] = useState(null);

    // The mechanism with valEmitState is very important for the datepicker to work properly.
    // If calling props.onChange() directly from within a callback function of the datepicker, it won't have the current state values
    // (also from states in the parent, e.g. when setting another state in props.onChange()).
    // It is also not possible to run the picker after every render as the picker becomes unusable.
    const [valEmitState, setValEmitState] = useState(null);


    function handleBtnClick() {
        if(pickerBoxHeight === 0) {
            showPicker();
        }
        else {
            hidePicker();
        }
    }

    function handleKeyDown(e) {
        if(e.key == "Enter" && props.onEnter != undefined){
            props.onEnter();
        }
    }

    function handleChange(e) {
        setDisplayStr(e.target.value);
        checkDate(e.target.value, true);
        setManualErrorTextInternal(null);
    }

    // Returns a display format string and takes an ISO datetime string as input 
    function toDisplayDateFormat(isoStr) {
        if(isoStr === ""){
            return "";
        }

        if(props.time) {
            return moment(isoStr).format("DD.MM.YYYY, HH:mm") + " Uhr";
        }
        else {
            return moment(isoStr).format("DD.MM.YYYY");
        }
    }

    // Returns an date objrect and takes a display format string as input
    function createDateFromDisplayStr(displayFormatStr) {
        if(displayFormatStr === ""){
            return null;
        }

        if(props.time) {
            displayFormatStr = displayFormatStr.slice(0, -4);
            return moment(displayFormatStr, "DD.MM.YYYY, HH:mm").toDate();
        }
        else {
            return moment(displayFormatStr, "DD.MM.YYYY").toDate();
        }
    }

    // Create the correct string for the date input element
    function getDateInputISOStr(isoStr) {
        if(props.time) {
            return isoStr;
        }
        else {
            return moment(isoStr).format("YYYY-MM-DD");
        }
    }

    function pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    }

    function padDateStrWithZeroes(displayStr) {
        const splits = displayStr.split(".");

        if(splits.length !== 3) {
            return displayStr;
        }

        return pad(splits[0], 2) + "." + pad(splits[1], 2) + "." + splits[2];
    }

    function padDisplayStrWithZeroes(displayStr) {
        if(props.time) {
            const splits = displayStr.split(",");

            if(splits.length !== 2) {
                return displayStr;
            }

            return padDateStrWithZeroes(splits[0] + "," + splits[1]);
        }
        else {
            return padDateStrWithZeroes(displayStr);
        }
    }

    function handleBlur(e) {
        setFocussed(false);

        const displayStr = padDisplayStrWithZeroes(e.target.value);
        checkDate(displayStr);

        if(props.onBlur) {
            props.onBlur();
        }

        setManualErrorTextInternal(props.manualErrorText);
    }

    function checkDate(displayStr, doNotDisplayError=false, doNotUpdatePicker=false) {
        setErrorText(null);
        let newErrMsg = "";

        try{
            // Get an ISO datetime string from the displayed string:

            const date = createDateFromDisplayStr(displayStr);

            if(date === null) {
                if(!doNotUpdatePicker && datePickerRef.current) {
                    const zeroTimedate = new Date();
                    zeroTimedate.setHours(0);
                    zeroTimedate.setMinutes(0),

                    datePickerRef.current.selectDate(zeroTimedate, {silent: true, updateTime: true}); // To also remove the time
                    datePickerRef.current.clear({silent: true});
                    // datePickerRef.current.viewDate = undefined;
                    // datePickerRef.current.update();
                }

                // props.onChange(null);
                setValEmitState({value: null});
                return;
            }

            // Check whether the format is correct:

            newErrMsg = props.time ? locale.msgs.INVALID_DATETIME : locale.msgs.INVALID_DATE;
            const dateISOStr = date.toISOString();
            const newVal = toDisplayDateFormat(dateISOStr); // This can throw an error

            if(displayStr !== newVal) {
                throw new Error();
            }

            newErrMsg = "";

            if(!doNotUpdatePicker && datePickerRef.current) {
                // Already set the value for the date picker here as the format is valid and we want to to update it even if the date is e.g. too low etc.
                datePickerRef.current.selectDate(date, {silent: true, updateTime: true});
                datePickerRef.current.viewDate = date;  // Otherwise the year won't get updated
                datePickerRef.current.update();
            }

            // Extract the date and the time part from the ISO string:

            newErrMsg = checkMinMaxDate(date, props, locale);

            if(newErrMsg !== "") {
                throw new Error();
            }

            const correctIsoStr = getDateInputISOStr(dateISOStr);

            if(!doNotDisplayError) {    
                setDisplayStr(toDisplayDateFormat(dateISOStr));
            }

            // props.onChange(correctIsoStr);
            setValEmitState({value: correctIsoStr});
        }
        catch(error) {
            // console.log(error);

            if(!doNotDisplayError) {
                setErrorText(newErrMsg);
            }

            // props.onChange(null);
            setValEmitState({value: null});
        }
    }

    function handleFocus() {
        setFocussed(true);
    }

    function showPicker() {
        if(displayStr === "") {
            const d = new Date();

            if(!props.time) {
                d.setMilliseconds(0);
                d.setSeconds(0);
                d.setMinutes(0);
                d.setHours(0);
            }

            if(props.mustBeInFuture) {
                if(props.time) {
                    d.setMinutes(d.getMinutes() + 1); // Handles overflow automatically (e.g. for 13:59)
                }
                else {
                    d.setDate(d.getDate() + 1);
                }
            }

            const isoStr = d.toISOString();
            const displayStr = toDisplayDateFormat(isoStr);
            setDisplayStr(displayStr);

            lastPickerDatRef.current = d;

            datePickerRef.current.selectDate(d, {silent: true, updateTime: true});
            datePickerRef.current.viewDate = d;  // Otherwise the year won't get updated
            datePickerRef.current.update();

            // Also check here as we want to remove error messages if the date is now valid and it is also possible that
            // the date is currently not valid in terms of min/max etc.
            checkDate(displayStr, false, true);
        }

        datePickerBoxEleRef.current.style.transition = "height 0.2s";

        const height = datePickerBoxEleRef.current.scrollHeight;
        setPickerBoxHeight(height - 1);  // -1 as the calculation might be inaccurate due to scaling
        
        // Not scrolling immediately as we need to wait the scroll element did increase
        datePickerBoxEleRef.current.addEventListener("transitionend", handleTransitionEnd);
    }

    function hidePicker() {
        datePickerBoxEleRef.current.style.transition = "height 0.2s";

        setPickerBoxHeight(0);
        pickerShownRef.current = false;
    }

    function handleTransitionEnd() {
        datePickerBoxEleRef.current.removeEventListener("transitionend", handleTransitionEnd);

        const rect = datePickerBoxEleRef.current.getBoundingClientRect();

        if(props.onScroll) {
            props.onScroll(rect.top, rect.bottom);
        }
        else {
            scroll.scrollTo(rect.top, rect.bottom);
        }

        datePickerBoxEleRef.current.style.transition = "";
        pickerShownRef.current = true;
    }

    function calcPickerBox(scaleFactor, pickerBoxLeft) {
        if(pickerShownRef.current) {
            const newPickerHeight = datePickerEleRef.current.clientHeight;
            setPickerBoxHeight(newPickerHeight - 1);  // -1 as the calculation might be inaccurate due to scaling
        }

        let translatePctX = (scaleFactor - 1) / 2 * 100;
        let translatePctY = translatePctX;

        if(!pickerBoxLeft) {
            translatePctX = translatePctX * -1;
        }

        setPickerBoxTransform("translate(" + translatePctX + "%, " + translatePctY + "%) scale(" + scaleFactor + ")");
    }


    // EFFECTS:

    useEffect(() => {
        if(valEmitState !== null) {
            props.onChange(valEmitState.value);
            setValEmitState(null);
        }
    }, [valEmitState]);

    useLayoutEffect(() => {
        if(props.readOnly) {
            return;
        }

        datePickerRef.current = new AirDatepicker("#datepicker_" + pickerId, {
            inline: true,
            timepicker: props.time,
            minutesStep: 15,
            // maxMinutes: 45,  // To make the slider to have 45 minutes at the end of its range and not at 3/4 range, we can set this to 45.
                                // However this makes the picker not beeing able to handle minuts above 45
                                // (e.g. entering 48 on the text input results in erroneous behaviour)
            maxMinutes: 60,
            maxHours: 24,
            locale: localeDe,
            onSelect: (date, formattedDate, datepicker) => {
                if(!date.date) {
                    // This happens if the same date is selected -> Avoid unselecting
                    datePickerRef.current.selectDate(lastPickerDatRef.current);
                    datePickerRef.current.viewDate = lastPickerDatRef.current;  // Otherwise the year won't get updated
                    datePickerRef.current.update();
                    return;
                }

                lastPickerDatRef.current = date.date;

                const isoStr = date.date.toISOString();
                const displayStr = toDisplayDateFormat(isoStr);
                setDisplayStr(displayStr);

                // Also check here as we want to remove error messages if the date is now valid and it is also possible that
                // the date is currently not valid in terms of min/max etc.
                checkDate(displayStr, false, true);

                calcPickerBox();

                if(!props.time) {
                    hidePicker();
                }
            }
        });

        return () => datePickerRef.current.destroy();
    }, [props.readOnly]);

    useLayoutEffect(() => {
        if(props.value !== undefined && props.value !== null) {
            const displayStr = toDisplayDateFormat(props.value);

            setDisplayStr(displayStr);

            if(!props.readOnly) {
                checkDate(displayStr);
            }

            lastPickerDatRef.current = createDateFromDisplayStr(displayStr);
        }
    }, [props.value, props.readOnly]);

    useLayoutEffect(() => {
        if(props.readOnly) {
            setErrorText(null);
        }
    }, [props.readOnly]);

    useLayoutEffect(() => {
        if(!focussed) {
            setManualErrorTextInternal(props.manualErrorText);
        }
    }, [props.manualErrorText]);

    useLayoutEffect(() => {
        function handleClickAnywhere(e) {
            if(!btnRef.current.contains(e.target) && !datePickerBoxEleRef.current.contains(e.target)) {
                hidePicker();
            }
        }

        document.addEventListener("click", handleClickAnywhere, { capture: true });
        return () => document.removeEventListener("click", handleClickAnywhere, { capture: true });
    }, []);

    useLayoutEffect(() => {
        function handleClickAnywhere(e) {
            calcPickerBox(scaleFactor, pickerBoxLeft);
        }

        document.addEventListener("click", handleClickAnywhere);
        return () => document.removeEventListener("click", handleClickAnywhere);
    }, [pickerBoxLeft, scaleFactor]);

    useLayoutEffect(() => {
        let pickerBoxLeftVar = pickerBoxLeft;
        const rect = datePickerBoxEleRef.current.getBoundingClientRect();

        if(rect.left < 0) {
            setPickerBoxLeft(true);
            pickerBoxLeftVar = true;
            calcPickerBox(scaleFactor, pickerBoxLeftVar);
        }

        const viewportWidth = document.documentElement.clientWidth;
        const curPadding = 16;

        if(pickerBoxLeftVar && rect.right + curPadding * 2 > viewportWidth) {
            const origWidth = datePickerBoxEleRef.current.clientWidth;

            const newScaleFactor = viewportWidth / (origWidth + 50);  // Using a fixed value as horizontal centering by also using the padding did not work...
            setScaleFactor(newScaleFactor);

            calcPickerBox(scaleFactor, pickerBoxLeftVar);
        }
    });

    useLayoutEffect(() => {
        // Move the arrows up (we need to do this after picker is visible)
        const arrowEles = document.getElementsByClassName("air-datepicker-nav--action");

        if(arrowEles.length === 2) {
            arrowEles[0].children[0].children[0].setAttribute("d", "M 18,11 l -5,5 l 5,5");
            arrowEles[1].children[0].children[0].setAttribute("d", "M 14,11 l 5,5 l -5,5");
        }
    }, [pickerBoxHeight]);


    // RENDER:

    let type = "text";
    let autocomplete = "";

    if(props.type) {
        type = props.type;
    }

    if(props.autocomplete) {
        autocomplete = props.autocomplete;
    }

    return (
        <div className="date_input_box">
            <div ref={datePickerBoxEleRef} className="datepicker_box" style={{ height: pickerBoxHeight, transform: pickerBoxTransform,
                                                                               left: pickerBoxLeft ? "0" : null, right: pickerBoxLeft ? null : "0",
                                                                               }}>
                <div ref={datePickerEleRef} id={"datepicker_" + pickerId} className="datepicker"/>
            </div>

            <div className="abs_spacer_dummy" style={{height: (pickerBoxHeight + 50) * scaleFactor}}/>

            <div className={"input_box" + (props.minimal ? " input_box_minimal" : "")  +
                    (props.readOnly ? "" : (focussed ? " input_box_focus" : "") )}>
                <input ref={inputRef} className={"date_input_text input" +
                                                (props.minimal ? " input_minimal": "")}
                        type={type} name={props.name} placeholder=" "
                        value={displayStr} autoComplete={autocomplete}
                        onChange={handleChange} onKeyDown={handleKeyDown} onBlur={handleBlur} onFocus={handleFocus}
                        readOnly={props.readOnly}></input>

                {/*

                <input ref={dateInputRef} className="date_input" type={props.time ? "date" : "date"} name={props.name + "_date"}
                        onBlur={handleDateInputBlur} onClose={handleDateInputBlur}
                        onChange={handleDateInputChange} value={props.time ? convertIsoToLocalIsoWithoutTimezone(dateInputValue) : dateInputValue}
                        readOnly={props.readOnly}></input>
                

                <div className="date_input">
                    <ReactDatePicker ref={datePickerRef} className="custom_date_picker" selected={dateInputDate} onChange={(date) => {}}
                            popperPlacement="bottom-end" onClickOutside={() => setPickerShown(false)}
                            onSelect={handleDateInputSelect}
                            locale={de}
                    />
                </div>
                */}

                <div ref={btnRef} className={"date_btn no_tap_highlight" + (props.readOnly ? " date_btn_readonly" : "")}
                        onClick={props.readOnly ? () => {} : handleBtnClick}>
                    {
                        props.readOnly ? null :
                            <div>
                                <img className="date_btn_img" src="/common/icon_calendar.svg"/>
                            </div>
                    }
                </div>

                <div className={"input_name" + 
                        (props.minimal ?
                            " input_name_minimal" :
                            (props.showPlaceholderIfNotEmpty == undefined || props.showPlaceholderIfNotEmpty ?
                                props.readOnly && displayStr === "" ?
                                    ""
                                :
                                    " text_input_name"
                            :
                                props.readOnly ?    // Only hide this placeholder (e.g. on focus) if not read only
                                    ""
                                :
                                    " text_input_name_hide"
                            )
                        )}>
                    {props.text}
                </div>
            </div>

            { errorText !== null && !props.readOnly ?
                <div className="text_error_small input_error_text">{errorText}</div>
            :
                manualErrorTextInternal ?
                    <div className="text_error_small input_error_text">{manualErrorTextInternal}</div>
                :
                    null
            }

        </div>
    );
}

export function TextInputMultiline(props) {
    const locale = useContext(LocaleContext);

    const [focussed, setFocussed] = useState(false);
    const [errorText, setErrorText] = useState(null);

    const inputRef = useRef();

    const [height, setHeight] = useState(remToPixels(props.height));

    const [valueInternal, setValueInternal] = useState("");


    // FUNCTION:

    function handleBlur() {
        setFocussed(false);
    }

    function handleFocus() {
        if(props.readOnly) {
            return;
        }

        setFocussed(true);
    }

    function adjustHeight() {
        const ele = inputRef.current;

        const minHeight = remToPixels(props.height);

        const tempHeight = ele.style.height;
        
        ele.style.height = "0";

        const newHeight = ele.scrollHeight;

        if(newHeight > minHeight) {
            setHeight(newHeight);
        }
        else {
            setHeight(minHeight);
        }

        ele.style.height = tempHeight;
    }

    function restoreCursorPos() {
        const cursorPos = inputRef.current.cursorPos;

        if (cursorPos !== undefined) {
            inputRef.current.selectionStart = cursorPos;
            inputRef.current.selectionEnd = cursorPos;
        }
    }

    function checkError(value) {
        if(value.length > props.maxLength) {
            setErrorText(locale.msgs.ONLY_N_CHARS_ALLOWED.replace("${{max_characters}}", props.maxLength).replace("${{characters}}", value.length));
            
            if(props.onError) {
                props.onError(true);
            }

            return false;
        }

        if(!checkUtfString(value)) {
            setErrorText(locale.msgs.UNSPPORTED_CHARS);

            if(props.onError) {
                props.onError(true);
            }

            return false;
        }

        setErrorText("");

        if(props.onError) {
            props.onError(false);
        }

        return true;
    }

    function handleInputChange(e) {
        inputRef.current.cursorPos = inputRef.current.selectionStart;

        setValueInternal(e.target.value);
        props.onChange(e.target.value);
        checkError(e.target.value);
    }


    // EFFECTS:

    useLayoutEffect(() => {
        setValueInternal(props.value);
        checkError(props.value);  // Update the error text
    }, [props.value]);

    useLayoutEffect(() => {
        adjustHeight();
    }, [props.recalcTrigger]);

    useLayoutEffect(() => {
        adjustHeight();
        restoreCursorPos();
    }, [valueInternal]);


    // RENDER:

    return (
        <div className="text_input_multiline_box">
            <div className={"input_box multiline_input_box" + (focussed ? " input_box_focus" : "")} style={{"height": (height + 8)}}>
                <textarea ref={inputRef} className={"input multiline_input" + (props.tiny ? " multiline_input_tiny" : "")} placeholder=" " value={valueInternal} style={{"height": height}}
                        onChange={handleInputChange} readOnly={props.readOnly}
                        onBlur={handleBlur} onFocus={handleFocus}
                ></textarea>

                <div className={"input_name input_name_multiline" + (valueInternal === "" && props.readOnly ?  // Avoid that this disappears when the textarea is clicked
                            ""
                        :
                            (props.showPlaceholderIfNotEmpty == undefined || props.showPlaceholderIfNotEmpty ? " text_input_name" : " text_input_name_hide")
                        )}>
                    {props.text}
                </div>
            </div>

            { errorText !== null ?
                <div className="text_error_small input_error_text">{errorText}</div>
            :
                null
            }
        </div>
    );
}

export function SquareButton(props) {
    let color = "purple";
    let type = "button";

    if(props.white){
        color = "white";
    }

    if(props.submit) {
        type = "submit";
    }

    let className = "noselect button_square " +
        color + "_button_square " +
        color + (props.clickable ? "_button_square_clickable" : "_button_square_not_clickable ") +
        (props.small ? " button_square_small" : " button_square_big") +
        (props.smallPad ? " button_square_small_pad" : " button_square_pad");

    return(
        <button type={type} className={className} onClick={props.clickable ? props.onClick : ()=>{} }>{props.text}</button>
    );
}

export function SaveButton(props) {
    const locale = useContext(LocaleContext);

    let color = "purple";

    let className =
        (!props.smallPad ? "save_btn_pad" : "") + " save_btn button_square " +
        color + "_button_square " +
        color + (props.clickable ? "_button_square_clickable" : "_button_square_not_clickable ") +
        (props.small ? " button_square_small" : " button_square_big") +
        (props.smallPad ? " button_square_small_pad" : " button_square_pad");

    return(
        <div className="save_btn_box">
            <button type="button" className={className} onClick={props.clickable ? props.onClick : ()=>{} }>
                <div className="save_btn_text">
                    {props.text}

                    {
                        props.saving ?
                        <div className="loader save_btn_loader"></div>
                        : null
                    }
                    
                </div>
            </button>

            {
                props.saved ?

                <div className="suc_box">
                    <img className="save_btn_suc_img" src="/common/icon_done_green.svg"></img>
                    <div className="saved_text text_success_2">{locale.msgs.SAVED}</div>
                </div>
                : null
            }

            {
                props.notSaved ?

                <div className="err_box">
                    <div className="saved_text text_error_2">
                        {/* <img className="save_btn_err_img" src="/common/icon_close_red.svg"></img> */}
                        {locale.msgs.SAVING_FAILED}
                    </div>
                </div>
                : null
            }
            
        </div>
    );
}

export function LoadButton(props) {
    const locale = useContext(LocaleContext);

    let color = "purple";
    let type = "button";

    if(props.white){
        color = "white";
    }

    if(props.submit) {
        type = "submit";
    }

    let className = (!props.smallPad ? "save_btn_pad" : "") + " save_btn button_square " +
        color + "_button_square " +
        color + (props.clickable ? "_button_square_clickable" : "_button_square_not_clickable ") +
        (props.small ? " button_square_small" : " button_square_big") +
        (props.smallPad ? " button_square_small_pad" : " button_square_pad");

    const saving = props.saving;

    return(
        <div className="save_btn_box">
            <button type={type} className={className} onClick={props.clickable ? props.onClick : ()=>{} }>
                <div className={"save_btn_text"}>
                    <span style={{visibility: !props.smallPad || !saving ? "visible" : "hidden"}}>{props.text}</span>

                    {
                        saving ?
                        <div className={"loader save_btn_loader" + (color === "white" ? " save_btn_loader_white" : "") +
                                (props.smallPad ? " save_btn_loader_small_pad" : "")}></div>
                        : null
                    }
                    
                </div>
            </button>

            {
                props.saved ?

                <div className="suc_box">
                    <img className="save_btn_suc_img" src="/common/icon_done_green_no_circle.svg"></img>
                    <div className="saved_text text_success_2">{props.sucText}</div>
                </div>
                : null
            }

            {
                props.notSaved ?

                <div className="err_box">
                    <div className="saved_text text_error_2">
                        {/* <img className="save_btn_err_img" src="/common/icon_close_red.svg"></img> */}
                        {props.errText}
                    </div>
                </div>
                : null
            }
            
        </div>
    );
}

export function ButtonRound(props) {
    return(
        <button type="button" className="button_round" onClick={props.onClick}>{props.text}</button>
    );
}

export function RadioCheckButton(props) {
    let labelClassName = "radio_button_label " +
        (props.checked ? "radio_button_label_checked" : "radio_button_label_unchecked");

    let variant = "default";

    if(props.tiny) {
        variant = "tiny";
    }
    else if(props.multiline) {
        variant = "multiline";
    }

    let boxClassName = "radio_button_box" + (props.checked ? " radio_button_box_checked" : " radio_button_box_unchecked") +
            (" radio_button_box_variant_" + variant) +
            (props.noBackground ? " radio_button_box_no_background" : "") +
            (props.readOnly ? " radio_button_box_readonly" : "");

    return (
        <div className={boxClassName}>
            <input type={props.type} className={"input_radio_check radio_button" +
                                                (" radio_button_variant_" + variant) +
                                                (props.grayedOut ? " radio_button_grayed_out" : "")}
                    id={props.id} name={props.name} checked={props.checked} onChange={props.onChange}
                    readOnly={props.readOnly}></input>
            <label className={labelClassName} htmlFor={props.id}></label>
            <div className={"radio_button_text" + (props.smallFont ? " radio_button_text_small" : "") + (props.breakLine ? " radio_button_text_break_line" : "")
                    + (" radio_button_text_variant_" + variant)}>{props.text}</div>
        </div>
    );
}

export const CheckBoxSquare = ({readOnly, text, checked, onChange}) => {
    function handleClick() {
        if(!readOnly) {
            onChange(!checked);
        }
    }

    return (
        <div className={"checkbox_square_box noselect" + (checked ? " checkbox_square_box_checked" : "" ) + (readOnly ? " checkbox_square_box_readonly" : "" )}
                onClick={handleClick}> 
            <div className={checked ? "text_white" : "text_2"}>{text}</div>
        </div>
    );
}

export function ForwardsBackwardsBar(props) {
    const locale = useContext(LocaleContext);

    return (
        <div className="fowards_backwards_bar">
            <div id="backwards_box" style={{display: props.backwardsVisible ? "block" : "none" }}>
                <SquareButton clickable={props.backwardsClickable} small={true} white={true} text={props.backwardsText} onClick={props.onBackwards} />
            </div>

            <div id="fowards_box" style={{display: props.forwardsVisible ? "block" : "none" }}>
                <LoadButton clickable={props.forwardsClickable} text={props.forwardsText} onClick={props.onForwards}
                        saving={props.forwardsLoadState === LoadState.LOADING} errText={locale.msgs.ERROR}
                        notSaved={props.forwardsLoadState === LoadState.LOAD_ERROR} />
            </div>
        </div>
    );
}

export function BarButton(props) {
    let className = "bar_button" + (props.done ? " bar_button_done" : " bar_button_not_done") + (props.tiny ? " bar_button_tiny" : "") +
            (props.pending ? " bar_button_pending" : "");
    
    let icon = props.done ? 
        <img className="icon_done" src={"/common/icon_done.svg"}></img> :
        <img className="icon_arrow icon_arrow_right" src={"/common/icon_arrow-right.svg"}></img>;

    return (
        <button type="button" className={className} onClick={props.onClick}>
            
            { props.pending ?
                <img className="bar_button_pending_img" src="/management/icon_pending.svg" />
            :
                null
            }

            <div className={"bar_button_text" + (props.bottomText && props.bottomText !== "" && props.tiny ? " bar_button_text_tiny_with_bottom_text" : "")}>
                {props.text}
            </div>

            {icon}

            <div className={"bar_button_bottom_text" + (props.done ? " bar_button_bottom_text_done" : "") +
                    (props.tiny ? " bar_button_bottom_text_tiny" : "")}>
                {props.bottomText}
            </div>

        </button>
    );
}

export function BarButtonReverse(props) {
    return (
        <button type="button" className="bar_button bar_button_not_done bar_button_reverse" onClick={props.onClick}>
            <img className="icon_arrow icon_arrow_left" src={"/common/icon_arrow-left.svg"}></img>
            <div className="bar_button_text">{props.text}</div>
        </button>
    );
}

export function ProgressBar(props) {
    return (
        <div className="progress_bar">
            <div className="progress_bar_overlay" style={{width: props.pct}}></div>
        </div>
    );
}

export function DropdownMenu(props) {
    let [optionsHeight, setOptionsHeightState] = useState(0);
    let dropdownBoxRef = useRef();
    let optionsRef = useRef();
    let innerOptionsRef = useRef();
    let inputRef = useRef();
    let displayDivRef = useRef();
    const locale = useContext(LocaleContext);

    const [inputWidth, setInputWidth] = useState(0);
    const inputWidthRef = useRef(inputWidth);

    const optionRefArr = useRef([]);
    // const [optionsMinWidth, setOptionsMinWidth] = useState(0);
    // const optionsMinWidthRef = useRef(optionsMinWidth);

    const [text, setTextState] = useState(props.value);

    const valueRef = useRef(props.value);
    const optionsHeightRef = useRef(optionsHeight);


    // FUNCTIONS:

    function setOptionsHeight(height) {
        height = height - 2; // 1 for unaccuracy and 1 for the last border

        if(height < 0) {
            height = 0;
        }

        setOptionsHeightState(height);
        optionsHeightRef.current = height;
    }

    function setText(text) {
        setTextState(text ? text.replace(/<[^>]*>/g, '') : text);
    }

    function handleTransitionEnd(e) {
        props.onScroll(inputRef.current.getBoundingClientRect().top, optionsRef.current.getBoundingClientRect().top + optionsRef.current.scrollHeight);
        optionsRef.current.removeEventListener("transitionend", handleTransitionEnd);
        // optionsRef.current.style.overflow = "visible";
    }

    function handleInputClick(e) {
        if(optionsHeight == 0){
            setOptionsHeight(optionsRef.current.scrollHeight);

            if(props.onScroll != undefined) {
                optionsRef.current.addEventListener("transitionend", handleTransitionEnd);
            }

            // Manually focus in case the user did not click on the input element but e.g. the arrow
            inputRef.current.focus();

            // Move the cursor to the end

            if(props.textSearch) {
                const valueLength = inputRef.current.value.length;
                inputRef.current.setSelectionRange(0, valueLength);
                inputRef.current.scrollLeft = inputRef.current.scrollWidth;
            }
            // else -> Not moving the cursor and scrolling without text search enabled!
        }
        else {
            collapse();
        }
    }

    function handleInputChange(e) {
        setText(e.target.value);

        // None calling onValueChange() here as we only want to call it on valid options
        // props.onValueChange("");
    }

    function handleOptionClick(e) {
        if(e.target.textContent === props.noText) {
            props.onValueChange("");
        }
        else {
            props.onValueChange(e.target.firstElementChild.innerHTML);
        }
        
        collapse();
    }

    function collapse() {
        setOptionsHeight(0);

        if(props.onBlur) {
            props.onBlur();
        }

        setText(valueRef.current);

        inputRef.current.blur();  // To also blur when e.g. clicking on the scroll bar
    }

    /*function setOptionsMinWidthFunc(minWidth) {
        optionsMinWidthRef.current = minWidth;
        setOptionsMinWidth(minWidth);
    }*/


    // EFFECTS:

    useLayoutEffect(() => {
        valueRef.current = props.value;
    }, [props.value]);

    useLayoutEffect(() => {
        function handleClickAnywhere(e) {
            if (!dropdownBoxRef.current.contains(e.target)) {
                collapse();
            }
        }

        // Use "pointerdown" instead of "click" to avoid unfocus on text selections that start within the input text and end outside the input text
        document.addEventListener("pointerdown", handleClickAnywhere);
        return () => document.removeEventListener("pointerdown", handleClickAnywhere);
    }, [dropdownBoxRef]);

    /* useLayoutEffect(() => {
        if(!props.autoWidth) {
            return;
        }

        if(props.options) {
            // optionRefArr.current = optionRefArr.current.slice(0, props.options.length);
        }

        for(const optionRef of optionRefArr.current) {

            // E.g. the first element can be undefined if it equals ""
            if(optionRef === undefined) {
                continue;
            }

            if(optionRef.scrollWidth > optionsMinWidthRef.current) {
                setOptionsMinWidthFunc(optionRef.scrollWidth + 12);
            }
        }
    }, [props.options]); */

    useLayoutEffect(() => {
        setText(props.value);
    }, [props.value]);

    useLayoutEffect(() => {
        // We only want to update the height if the options are currently shown
        if(optionsHeightRef.current !== 0) {
            setOptionsHeight(innerOptionsRef.current.clientHeight);
        }
    }, [text]);

    useLayoutEffect(() => {
        const width = displayDivRef.current.getBoundingClientRect().width;
        setInputWidth(width === 0 ? 1 : width);  // Minimum of 1 to always show the cursor
    });


    // RENDER:

    let options = [];
    let options2 = [];
    let optionValues = props.options;

    if(props.optional) {
        optionValues = [props.noText].concat(optionValues);
    }

    for(let i = 0; i < optionValues.length; i++) {
        let o = optionValues[i];

        const optionEle = (
            <div className={"option option_border"} onClick={handleOptionClick} key={i}>
                <div ref={el => optionRefArr.current[i] = el} className={"option_text" + (props.autoWidth ? " option_text_auto_width" : "")}
                        dangerouslySetInnerHTML={{__html: sanitizeStr(o)}}></div>
            </div>
        );

        if(o != "") {
            // style={ i == optionValues.length-1 ? {"border-bottom-left-radius": "0.5rem", "border-bottom-right-radius": "0.5rem"} : {}}

            // Show the results which match the entered text first (only if text search is active)

            if(!props.textSearch || (o.toLowerCase().includes(text.toLowerCase())) || (props.alwaysShowOptionsFirst && props.alwaysShowOptionsFirst.includes(o))) {
                options.push(optionEle);
            }
            else {
                options2.push(optionEle);
            }
        }
    }

    const placeholder = props.showPlaceholderIfNotEmpty == undefined || props.showPlaceholderIfNotEmpty;
    const nameClassNameOnSelection = placeholder ? " text_input_name" : " text_input_name_hide";

    const inputClassNames = "input dropdown_input no_tap_highlight" +
            (props.bold ? " input_bold": "") + // Before input_minimal, so it has more relevance
            (props.minimal ? " input_minimal": "") +
            " input_hover" + (props.no_border ? " no_border" : "") +
            (optionsHeight != 0 ? " dropdown_input_selecting" : "") +
            (optionsHeight != 0 && props.textSearch ? " dropdown_input_selecting_text_search" : "") +
            (props.left ? " dropdown_input_left" : "");
    const inputValue = props.minimal && props.optional && text === "" ? "-" : text;

    return (
        <div ref={dropdownBoxRef} className={"input_box dropdown_box" + (props.readOnly ? "" : (optionsHeight != 0 ? " input_box_focus" : "") ) +
                (props.minimal ? " input_box_minimal" : "") + (props.readOnly ? " dropdown_box_readonly" : "") + (props.no_border ? " dropdown_box_no_border" : "")}
                onClick={handleInputClick}>

            <input type="text" ref={inputRef} readOnly={!props.textSearch}
                    style={{position: "initial", width: !props.autoWidth ? "100%" : inputWidth}}
                    // Not setting readOnly to prevent the cursor from jumping on focus as otherwise the keyboard does not appear on mobile devices (at least on IOS)
                    // readOnly={optionsHeight === 0} // Also set readOnly to prevent the cursor from jumping on focus
                    className={inputClassNames}
                    onChange={handleInputChange}
                    onClick={(e) => {
                        if(props.textSearch && optionsHeight != 0) {
                            e.stopPropagation();
                        }
                    }}
                    value={inputValue}
                    placeholder={props.textSearch && optionsHeight != 0 ? props.textSearchInstruction : null}
            ></input>

            {/* We use a dummy div to be able to calculate the width required by the text currently shown in the input element */}
            <div ref={displayDivRef} className={inputClassNames} style={{position: "absolute", width: "auto", height: 0, whiteSpace: "pre" /* Otherwise trailing spaces would not be computed */}}>
                {inputValue}
            </div>

            <div ref={optionsRef} className={"dropdown_options_box" + (props.minimal ? " dropdown_options_box_minimal": "")
                    + (props.left ? " dropdown_options_box_left": "")}
                    style={{height: optionsHeight/*, minWidth: optionsMinWidth*/, width: props.autoWidth ? "auto" : "100%"}}>
                
                {/* We need an inner box to be able to know the height after a text change (the height on the outer box is required to be able to animate) */}
                <div ref={innerOptionsRef}>
                    {options}
                    {options2}
                </div>
            </div>

            <div className="abs_spacer_dummy" style={{height: (optionsHeight + 15)}}/>

            {
                props.no_border ? null :
                
                <div className={"input_name" +
                        (optionsHeight != 0 ? " input_name_focus" : "") +

                        (props.minimal ?
                            " input_name_minimal" :
                            (props.value != "" || (optionsHeight != 0 && props.textSearch) ? nameClassNameOnSelection : "")
                        )}
                        
                        style={{background: (props.value != "" || (optionsHeight != 0 && props.textSearch) ? " white" : "none")}}>
                        {/*<div className="input_name_background" style={{background: (props.value != "" ? " white" : "none")}}></div>*/}
                        {props.text + (props.optional ? " (" + locale.msgs.OPTIONAL + ")" : "")}
                </div>
            }

            {/*
            <div className={"dropdown_selection" + (props.minimal ? " dropdown_selection_minimal" : "") + (props.readOnly ? " dropdown_selection_readonly" : "") +
                    (props.no_border ? " dropdown_selection_no_border" : "")}>{props.minimal && props.optional && props.value === "" ? "-" : props.value}</div>
            */}

            {
                props.readOnly ? null :
                    <img className={"noselect dropdown_icon_grey" + (props.minimal ? " dropdown_icon_grey_minimal" : "") +
                                (props.no_border ? " dropdown_icon_grey_no_border" : "")}
                            src={optionsHeight != 0 ? "/common/icon_drop-down-pink.svg" : "/common/icon_drop-down-grey.svg"}></img>
            }
        </div>
    );
}

export function DropdownMenuWithManualError(props) {
    return(
        <div className="dropdown_menu_with_man_error">
            <DropdownMenu {...props} />

            { props.manualErrorText ?
                <div className="text_error_small input_error_text">{props.manualErrorText}</div>
            :
                null
            }

        </div>
    )
}

export function HelpBtn(props) {
    return(
        <img className="help_btn" src="/common/icon_help.svg" onClick={props.onClick}></img>
    );
}

export function CloseButtonBig(props) {
    return(
        <div className="right_corner_button_box">
            <img className="btn_big" src="/common/icon_close-big.svg" onClick={props.onClick}></img>
        </div>
    );
}

export function BurgerButtonBig(props) {
    const navigateLock = useContext(NavigateLockContext);

    return(
        <div className="right_corner_button_box">
            <img className="btn_big" src="/common/icon_menu.svg"
                    onClick={(e) => navigateLock.handleLockProtectedClick(e, (e) => props.onClick())}></img>
        </div>
    );
}

export function BackButton(props) {
    return(
        <img className="btn" src="/common/icon-back.svg" onClick={props.onClick}></img>
    );
}

export function LearnMore(props) {
    const locale = useContext(LocaleContext);

    return(
        <div className="learn_more" onClick={props.onClick}>
            <div className="text_small_small_bold learn_more_text">{locale.msgs.LEARN_MORE}</div>
            <img className="learn_more_img" src="/common/icon_more.svg"></img>
        </div>
    );
}

export function LangSelection(props) {
    const generalLocale = useContext(LocaleContext);

    const navigate = useNavigate();  // Do not use useNavigateSmart()!

    const localeLangMapping = {
        de: "Deutsch",
        en: "English"
    };

    function getLocaleFromLanguage(language) {
        for(let [k, v] of Object.entries(localeLangMapping)) {
            if(v === language) {
                return k;
            }
        }
    }

    function getLanguageFromLocale(language) {
        for(let [k, v] of Object.entries(localeLangMapping)) {
            if(k === language) {
                return v;
            }
        }
    }

    return(
        <div className={"lang_dropdown_box" + (props.noMargin ? " lang_dropdown_box_no_marg" : "")}>
                <img className="lang_icon" src="/common/icon_language.svg"></img>
                <div className="lang_dropdown">
                    <DropdownMenu text="" options={Object.values(localeLangMapping)}
                                value={getLanguageFromLocale(generalLocale.locale)}
                                onValueChange={(value) => {
                                    const params = new URLSearchParams(location.search);  

                                    const newLoc = getLocaleFromLanguage(value);

                                    if(newLoc == "de") {
                                        params.delete("lang");
                                    }
                                    else {
                                        params.set("lang", newLoc);
                                    }
                                    
                                    navigate(`?${params.toString()}`, { replace: true });
                                }}
                                onScroll={props.onScroll}
                                no_border={true}
                                autoWidth={true} />
                </div>
            </div>
    );
}

export function DropdownInfo(props) {
    const scroll = useContext(ScrollContext);

    const textRef = useRef();
    const boxRef = useRef();

    const textHeightRef = useRef();
    const openedRef = useRef(false);
    const transitionActive = useRef(false);
    const setHeightAfterTransition = useRef(false);
    const transitionEndExecuted = useRef(true);

    const [textHeight, setTextHeight] = useState(0);
    const [open, setOpen] = useState(0);


    // FUNCTIONS:

    function handleTransitionEnd(e) {
        if(!boxRef.current) {
            return;
        }

        transitionEndExecuted.current = true;

        if(setHeightAfterTransition.current) {
            calcTextHeight();
        }

        // A scrollbar will already be there, so this should always return the final top / bottom
        if(!props.noScrollOnOpen) {
            const rect = boxRef.current.getBoundingClientRect();
            scroll.scrollTo(rect.top, rect.bottom, true, props.scrollToTop);
        }

        textRef.current.removeEventListener("transitionend", handleTransitionEnd);
        transitionActive.current = false;
    }

    function handleClick(e) {
        if(textHeight !== 0) {
            setTextHeight(0);

            if(props.onOpenChange) {
                props.onOpenChange(false);
            }
        }
        else {
            transitionActive.current = true;
            setHeightAfterTransition.current = false;

            setTextHeight(textRef.current.scrollHeight);
            textRef.current.addEventListener("transitionend", handleTransitionEnd);

            if(props.onOpenChange) {
                props.onOpenChange(true);
            }
        }
    }

    function calcTextHeight() {
        textRef.current.style.height = "auto";     // Originally: Otherwise scrollHeight does not work for smaller heights -> When enlarging the browser window
                                                   // the dropdowninfo is not getting smaller.
                                                   // Then: This had to be removed because the transition was disrupted which lead to the transitionend event
                                                   //       not beeing fired anymore and therefore no scrolling was performed anymore.
                                                   // Now: Call calcTextHeight() after the transition

        setTextHeight(textRef.current.scrollHeight);
    }


    // EFFECTS:

    useLayoutEffect(() => {
        // Delay the opening for one render cycle
        if(props.open) {
            setOpen(1);
        }
    }, [props.content, props.successContent, props.open]);

    useLayoutEffect(() => {
        textHeightRef.current = textHeight;
    }, [textHeight]);

    useLayoutEffect(() => {
        function perform() {
            if(textHeightRef.current !== 0) {
                if(!transitionActive.current) {
                    calcTextHeight();
                }
                else {
                    setHeightAfterTransition.current = true;
                }
            }
        }

        perform();

        window.addEventListener("resize", perform);
        return () => window.removeEventListener("resize", perform);
    }, [props.recalcTrigger]);

    useLayoutEffect(() => {
        if(open >= 1 && open < 2) {
            setOpen(open + 1);
        }
        else if(open === 2) {
            if(!openedRef.current) {
                setTextHeight(textRef.current.scrollHeight);
                textRef.current.addEventListener("transitionend", handleTransitionEnd);
                openedRef.current = true;

                // Backup in case transitionend is not getting executed
                transitionEndExecuted.current = false;
                setTimeout(() => {
                    if(!transitionEndExecuted.current) {
                        handleTransitionEnd();
                    }
                }, 200);
            }
        }
    }, [open]);

    useLayoutEffect(() => {
        // Added props.close to not affect other functionality based on props.open
        if(props.close) {
            setTextHeight(0);

            if(props.onOpenChange) {
                props.onOpenChange(false);
            }
        }
    }, [props.close]);

    const dark = props.theme === "dark" && !props.success;
    const grayDot = props.theme === "bright-gray-dot" && !props.success;

    return (
        <div ref={boxRef} className={"dropdown_info_box" + (textHeight !== 0 ? " dropdown_info_box_open" : "") +
                                    (dark ? " dropdown_info_box_dark" : "") +
                                    (props.minimal ? " dropdown_info_box_minimal" : "") +
                                    (props.noMargin ? " dropdown_info_box_no_margin" : "") }
                onClick={handleClick}>
            <div className="dropdown_info_box_head noselect">
                { !props.minimal && !props.noCircle ?
                    <div className={"dropdown_info_box_circle" + (dark ? " dropdown_info_box_circle_dark" : "") +
                            (grayDot ? " dropdown_info_box_circle_gray_dot" : "") +
                            (props.success ? " dropdown_info_box_circle_success" : "")}>
                        {
                            props.success ?
                            <img src="/common/icon_done-filled.svg"></img>
                            :
                            <div className="dropdown_info_box_number">{props.number}</div>
                        }
                    </div>
                :
                    null
                }
                
                <div className={"dropdown_info_box_name" + (dark ? " dropdown_info_box_name_dark" : "") + (props.minimal ? " dropdown_info_box_name_minimal" : "") + (props.noCircle ? " dropdown_info_box_no_circle" : "")}>
                    {props.name}
                </div>

                { !props.minimal ?
                    <img className="dropdown_info_box_arrow" src={ textHeight !== 0 ? "/common/icon_arrow-up.svg" : "/common/icon_arrow-down.svg"}></img>
                :
                    null
                }

            </div>

            <div ref={textRef} className={"dropdown_info_box_text" + (textHeight !== 0 ? " dropdown_info_box_text_open" : "") + (textHeight !== 0 && props.minimal ? " dropdown_info_box_text_open_minimal" : "")}
                    style={{height: textHeight, transition: "height 0.05s" /* DO NOT FORGET TO ADJUST THE BACKUP TIMEOUT ABOVE */}}>
                {props.success ? props.successContent : props.content}
            </div>
        </div>
    );
}

export function SignupBox(props) {
    const commonLocale = useContext(LocaleContext);

    return (
        <div className="signup_box">
            <div className="text_big_big">{props.header}</div>
            <div className="text" dangerouslySetInnerHTML={{__html: sanitizeStr(props.descr)}}></div>
            
            <div className="sign_up_btn_in_signup_box">
                <ButtonRound text={commonLocale.msgs.REGISTER} onClick={props.onClick}/>
            </div>
        </div>
    );
}

export function TabSwitch(props) {
    const state = useContext(StateContext);
    const navigateLock = useContext(NavigateLockContext);
    const location = useLocation();

    const [currentTabIdx, setCurrentTabIdx] = useState(0);
    const [showSelectedTabName, setShowSelectedTabName] = useState(false);

    const [tabElementWidth, setTabeElementWidth] = useState(0);
    const [tabElementBoxOverflow, setTabElementBoxOverflow] = useState("visible");

    const tabNameRefArr = useRef([]);
    const [tabNameWidthArr, setTabNameWidthArr] = useState(null);
    const lastNoOfTabs = useRef(-1);

    const [scrollHintLeftVisible, setScrollHintLeftVisible] = useState(false);
    const [scrollHintRightVisible, setScrollHintRightVisible] = useState(false);

    const arr = Array(props.tabNames.length).fill(0);
    arr[0] = "auto";
    const [tabElementHeightArr, setTabElementHeightArr] = useState(arr);

    const tabBoxRef = useRef();
    const tabNameBoxRef = useRef();
    const initRef = useRef(true);
    const updateHeightArrRef = useRef(false);


    // FUNCTIONS:

    function scrollToTabName(i) {
        const tabNameBoxEle = tabNameBoxRef.current;

        const tabNameBoxStartX = tabNameBoxEle.getBoundingClientRect().left;
        const tabNameStartX = tabNameRefArr.current[i].getBoundingClientRect().left;

        const tabNameBoxEndX = tabNameBoxEle.getBoundingClientRect().right;
        const tabNameEndX = tabNameRefArr.current[i].getBoundingClientRect().right;

        const tabNameWidth = tabNameEndX - tabNameStartX;

        let offset = 46;

        if(tabNameStartX < tabNameBoxStartX + offset) {
            tabNameBoxEle.scrollTo(tabNameStartX - (tabNameBoxStartX - tabNameBoxEle.scrollLeft) - offset, 0);
        }

        if(tabNameEndX > tabNameBoxEndX - offset) {
            tabNameBoxEle.scrollTo(tabNameEndX - (tabNameBoxStartX - tabNameBoxEle.scrollLeft) - tabNameWidth, 0);
        }
    }

    function handleTabClick(i) {
        if(props.clickHandler) {
            if(!props.clickHandler(i)) {
                return;
            }
        }

        scrollToTabName(i);

        // tabNameBoxRef.current.scrollTo(, 0);
        switchTab(i);
    }

    function switchTab(i) {
        const arr = Array(props.tabNames.length).fill(0);
        arr[currentTabIdx] = "auto";
        arr[i] = "auto";

        setTabElementBoxOverflow("hidden");
        setTabElementHeightArr(arr);
        setCurrentTabIdx(i);
    }

    function calcTabElementWidth() {
        const width = tabBoxRef.current.clientWidth;
        setTabeElementWidth(width - 1);
    }

    function handleTabNameBoxScroll(e) {
        setScrollHintVisibility(e.target);
    }

    function setScrollHintVisibility(ele) {
        if(ele.scrollLeft <= 0) {
            setScrollHintLeftVisible(false);
        }
        else {
            setScrollHintLeftVisible(true);
        }

        if(ele.scrollLeft >= (ele.scrollWidth - ele.clientWidth) - 1) {
            setScrollHintRightVisible(false);
        }
        else {
            setScrollHintRightVisible(true);
        }
    }

    function calcTabElementHeightArr(currentTabIdx) {
        setTabElementHeightArr((curArr) => {
            const arr = Array(props.tabNames.length).fill(0);
            arr[currentTabIdx] = "auto";
            return arr;
        });
        setTabElementBoxOverflow("visible");
    }
    

    // EFFECTS:

    useLayoutEffect(() => {
        tabNameRefArr.current = tabNameRefArr.current.slice(0, props.tabNames.length);
    }, [props.tabNames]);

    useLayoutEffect(() => {
        calcTabElementWidth();

        // window.addEventListener("resize", calcTabElementWidth);
        // return () => window.removeEventListener("resize", calcTabElementWidth);
    });

    useLayoutEffect(() => {
        if(props.currentTabIdx !== undefined && props.currentTabIdx !== null) {
            if(props.currentTabIdx != currentTabIdx) {
                switchTab(props.currentTabIdx);

                if(initRef.current) {
                    // Also here the animation is not triggered so we need to call calcTabElementHeightArr() in the next render cycle
                    updateHeightArrRef.current = true;
                }
            }
        }
    }, [props.currentTabIdx]);

    useLayoutEffect(() => {
        // Do not execute this initially because if the props.currentTabIdx is different from the internal currentTabIdx an infinite loop will be created
        if(initRef.current) {
            initRef.current = false;
            return;
        }

        if(updateHeightArrRef.current) {
            updateHeightArrRef.current = false;
            calcTabElementHeightArr(currentTabIdx);
        }

        if(props.setTabIdx) {
            props.setTabIdx(currentTabIdx);
            scrollToTabName(currentTabIdx);
        }
    }, [currentTabIdx]);

    useLayoutEffect(() => {
        if(tabNameRefArr.current.length !== lastNoOfTabs.current) {
            lastNoOfTabs.current = tabNameRefArr.current.length;
            setTabNameWidthArr(null); // Recalculate the widths if the number of tabs changes

            if(props.currentTabIdx === currentTabIdx) {
                // We also want to set the height array here as no transition will occur and therefore no call to calcTabElementHeightArr() will be made
                calcTabElementHeightArr(currentTabIdx);
            }
        }
    });

    useLayoutEffect(() => {
        // Lock the tab widths to avoid movements on font weight changes

        if(tabNameWidthArr === null) {
            let arr = Array(tabNameRefArr.current.length);

            for(let i = 0; i < tabNameRefArr.current.length; i++) {
                const ele = tabNameRefArr.current[i];
                const style = getComputedStyle(ele);

                arr[i] = ele.clientWidth - parseFloat(style.paddingRight) - parseFloat(style.paddingLeft);
            }

            setTabNameWidthArr(arr);
        }
    });

    useLayoutEffect(() => {
        function perform() {
            setScrollHintVisibility(tabNameBoxRef.current);
        }

        setScrollHintVisibility(tabNameBoxRef.current);

        window.addEventListener("resize", perform);
        return () => window.removeEventListener("resize", perform);
    }, []);

    useLayoutEffect(() => {
        // Delay this as we want the tab name width's to be calculated correctly
        setShowSelectedTabName(true);
    }, []);


    // RENDER:

    let tabNames = [];
    let tabElements = [];

    for(let i = 0; i < props.tabNames.length; i++) {
        const name = props.tabNames[i];
        const ele = props.tabElements[i];

        tabNames.push(
            <div key={"tab_name_" + i} className={"tab_name noselect" + (i === currentTabIdx && showSelectedTabName ? " tab_border_selected text_pink" : " text_2") + 
                            (props.sameTabWidth ? " tab_name_same_tab_width" : "") + (i === 0 ? " tab_name_first" : "")
                            + (i === props.tabNames.length - 1 ? " tab_name_last" : "")}
                    onClick={(e) => navigateLock.handleLockProtectedClick(e, (e) => handleTabClick(i))}
                    style={{"width": tabNameWidthArr === null ? null : tabNameWidthArr[i]}}
                    ref={el => tabNameRefArr.current[i] = el}
            >
                {name}
            </div>
        );

        tabElements.push(
            <div key={"tab_element_" + i} className={"tab_element" + (i === currentTabIdx ? " tab_element_visible" : "")}
                    style={{width: (i === currentTabIdx ? tabElementWidth : 0), height: tabElementHeightArr[i]}}
                    onTransitionEnd={ i !== currentTabIdx ? (e) => {
                        calcTabElementHeightArr(currentTabIdx);
                    } : ()=>{}}>

                <div className="tab_element_size_preserver" style={{width: tabElementWidth}}>
                    {ele}
                </div>

                {/* To avoid the border of tab_name with negative margin from reaching into the tab_element */}
                <div className="tab_element_border_fix"></div>

            </div>
        );
    }

    return (
        <div className="tab_switch_box">
            <div className="tab_switch">
                <div className="tab_name_box_box">
                
                    <div className="tab_name_box_scroll tab_name_box_scroll_left" style={{opacity: (scrollHintLeftVisible ? 1.0 : 0.0)}}></div>
                    <div className="tab_name_box_scroll tab_name_box_scroll_right" style={{opacity: (scrollHintRightVisible ? 1.0 : 0.0)}}></div>
                

                    <div ref={tabNameBoxRef} className={"tab_name_box" + (navigator.webdriver ? "" : " noscrollbar")} onScroll={handleTabNameBoxScroll}>
                        {tabNames}
                    </div>
                </div>

                <div ref={tabBoxRef} className={"tab_element_box"
                                                    + (currentTabIdx >= 1 ? " tab_element_box_left_rad" : "")
                                                    + (currentTabIdx < props.tabNames.length - 1 ? " tab_element_box_right_rad" : "")
                                                }
                        style={{overflow: tabElementBoxOverflow}}>
                    {tabElements}
                </div>
            </div>
        </div>
    );
}

export function ForMnSteps(props) {
    const locale = useContext(LocaleContext);
    const state = useContext(StateContext);

    const loadMeeting = useRef(false);

    const [sucArr, setSucArr] = useState(Array(6).fill(false));
    const [openArr, setOpenArr] = useState(Array(6).fill(false));

    const [dropdownRecalcTrigger, setDropdownRecalcTrigger] = useState(false);
    
    const navigate = useNavigateSmart();
    
    
    let theme = "bright";
    let dashboard = false;

    if(props.mode === "dashboard") {
        theme = "dark";
        dashboard = true;
    }

    useLayoutEffect(() => {
        if(props.mediationStatus == MediationStatus.APPLICATION_INTERESTING) {
            setSucArr([true, false, false, false, false, false]);
            setOpenArr([true, false, false, false, false, false]);
        }
        else if(props.mediationStatus == MediationStatus.ONLINE_MEETING) {
            setSucArr([true, true, false, false, false, false]);
            setOpenArr([false, true, false, false, false, false]);
            loadMeeting.current = true;
        }
        else if(props.mediationStatus == MediationStatus.FIND_MATCH || props.mediationStatus == MediationStatus.VOTING) {
            setSucArr([true, true, true, false, false, false]);
            setOpenArr([false, false, true, false, false, false]);
            loadMeeting.current = true;
        }
        else if(props.mediationStatus == MediationStatus.MATCH_FOUND) {
            setSucArr([true, true, true, true, false, false]);
            setOpenArr([false, false, false, true, false, false]);
            loadMeeting.current = true;
        }
        else if(props.mediationStatus == MediationStatus.FINAL_CONFIRMATION) {
            setSucArr([true, true, true, true, true, false]);
            setOpenArr([false, false, false, false, true, false]);
            loadMeeting.current = true;
        }
        else if(props.mediationStatus == MediationStatus.MEDIATION_DONE) {
            setSucArr([true, true, true, true, true, true]);
            setOpenArr([false, false, false, false, false, true]);
            loadMeeting.current = true;
        }
    }, [props.mediationStatus]);
    
    return (
        <div>
            <DropdownInfo number="1" theme={theme} success={sucArr[0]} open={openArr[0]}
                    name={ dashboard ? locale.msgs.STEP_1_MN_TITLE_DASHBOARD : locale.msgs.STEP_1_MN_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_1_MN_DESCR_DASHBOARD : locale.msgs.STEP_1_MN_DESCR_WEBSITE) }}></div>}
                    successContent={
                            <div className="first_info_suc_box">
                                <div dangerouslySetInnerHTML={{__html: locale.msgs.STEP_1_MN_DESCR_DASHBOARD_DONE}}></div>
                                <div className="first_info_suc_btn">
                                    <SquareButton text={locale.msgs.MY_PROFILE} clickable={true} onClick={() => {
                                        navigate("profile/?tab=documents");
                                    }}/>
                                </div>
                            </div>
                        } />

            <DropdownInfo number="2" theme={theme} success={sucArr[1]} open={openArr[1]} recalcTrigger={dropdownRecalcTrigger}
                    name={ dashboard ? locale.msgs.STEP_2_MN_TITLE_DASHBOARD : locale.msgs.STEP_2_MN_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_2_MN_DESCR_DASHBOARD : locale.msgs.STEP_2_MN_DESCR_WEBSITE) }}></div>}
                    successContent={
                        <FirstContactSuc descr={locale.msgs.STEP_2_MN_DESCR_DASHBOARD_DONE} onLoad={() => setDropdownRecalcTrigger(!dropdownRecalcTrigger)} />
                    }/>

            <DropdownInfo number="3" theme={theme} success={sucArr[2]} open={openArr[2]}
                    name={ dashboard ? locale.msgs.STEP_3_MN_TITLE_DASHBOARD : locale.msgs.STEP_3_MN_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_3_MN_DESCR_DASHBOARD : locale.msgs.STEP_3_MN_DESCR_WEBSITE) }}></div>}
                    successContent={<div dangerouslySetInnerHTML={{__html: locale.msgs.STEP_3_MN_DESCR_DASHBOARD_DONE }}></div>}
            />

            <DropdownInfo number="4" theme={theme} success={sucArr[3]} open={openArr[3]}
                    name={ dashboard ? locale.msgs.STEP_4_MN_TITLE_DASHBOARD : locale.msgs.STEP_4_MN_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_4_MN_DESCR_DASHBOARD : locale.msgs.STEP_4_MN_DESCR_WEBSITE) }}></div>}
                    successContent={
                        <div className="first_info_suc_box">
                            <div dangerouslySetInnerHTML={{__html: locale.msgs.STEP_4_MN_DESCR_DASHBOARD_DONE}}></div>
                            <div className="first_info_suc_btn">
                                <SquareButton text={locale.msgs.MY_MATCH} clickable={true} onClick={() => navigate("match/")} />
                            </div>
                        </div>
                    }
            />

            <DropdownInfo number="5" theme={theme} success={sucArr[4]} open={openArr[4]}
                    name={ dashboard ? locale.msgs.STEP_5_MN_TITLE_DASHBOARD : locale.msgs.STEP_5_MN_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_5_MN_DESCR_DASHBOARD : locale.msgs.STEP_5_MN_DESCR_WEBSITE) }}></div>}
                    successContent={
                        <div className="first_info_suc_box">
                            <div className="noselect" dangerouslySetInnerHTML={{__html: locale.msgs.STEP_5_MN_DESCR_DASHBOARD_DONE}}></div>
                            <div className="first_info_suc_btn">
                                <SquareButton text={locale.msgs.MY_MATCH} clickable={true} onClick={() => navigate("match/")} />
                            </div>
                        </div>
                    }
            />

            <DropdownInfo number="6" theme={theme} success={sucArr[5]} open={openArr[5]}
                    name={ dashboard ? locale.msgs.STEP_6_MN_TITLE_DASHBOARD : locale.msgs.STEP_6_MN_TITLE_WEBSITE }
                    content={<div className="noselect" dangerouslySetInnerHTML={{__html: (dashboard ? locale.msgs.STEP_6_MN_DESCR_DASHBOARD : locale.msgs.STEP_6_MN_DESCR_WEBSITE) }}></div>}
                    successContent={<div dangerouslySetInnerHTML={{__html: locale.msgs.STEP_6_MN_DESCR_DASHBOARD_DONE }}></div>}
            />
        </div>
    )
}

export const FirstContactSuc = ({descr, onLoad}) => {
    const locale = useContext(LocaleContext);

    const location = useLocation();

    const [onlineMeetingDate, setOnlineMeetingDate] = useState(locale.msgs.LOADING);
    const [onlineMeetingUrl, setOnlineMeetingUrl] = useState(locale.msgs.LOADING);

    function handleUrlClick() {
        // Open a new tab with the specified URL
        window.open(onlineMeetingUrl, '_blank');
    }

    const [loadState, setLoadState] = useAutoLoad((json) => {
        // On load success
        setOnlineMeetingDate(new Date(json.online_appointment_date).toLocaleString(undefined, {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        }));
        setOnlineMeetingUrl(json.online_appointment_url);

        if(onLoad) {
            onLoad();
        }

        // setLoadState(LoadState.LOADING); // For testing
    }, () => {
        // On load error
    }, () => {
        return "/user/get_online_meeting";
    });

    return(
        <div className="first_info_suc_box">
            <div className="noselect" dangerouslySetInnerHTML={{__html: sanitizeStr(descr)}}></div>

            { loadState === LoadState.LOADING || loadState === LoadState.NONE ?
                <div className="first_contact_loader_box">
                    <div className="loader first_contact_loader"></div>
                </div>
            :
                loadState === LoadState.LOAD_SUCCESS ?
                    <div className="online_meeting_info_box"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}>
                        <div className="online_meeting_info selectable">
                            <img className="online_meeting_info_cal_img" src="/common/icon_calendar-pink.svg"/>
                            <div className="online_meeting_info_text">{onlineMeetingDate}</div>
                        </div>
                        
                        <div className="online_meeting_info selectable">
                            <img className="online_meeting_info_link_img" src="/common/icon_link-pink.svg"/>
                            <div className="online_meeting_info_url" onClick={handleUrlClick}>{onlineMeetingUrl}</div>
                        </div>
                    </div>
                :
                    <div className="text_error">
                        {locale.msgs.LOAD_ERROR_ONLINE_MEETING}
                    </div>
            }

        </div>
    );
}

// This popup appears in the element flow
export function Popup(props) {
    const scroll = useContext(ScrollContext);
    
    const [overflow, setOverflow] = useState("hidden");

    let helpBox = useRef();
    let helpBoxBox = useRef();


    // FUNCTIONS:

    function handleTransitionEndVisible(e) {
        const rect = helpBox.current.getBoundingClientRect();
        scroll.scrollTo(rect.top, rect.bottom);

        setOverflow("visible");  // To also display absolute elements that go beyond this popup (e.g. a dropdown menu)

        helpBoxBox.current.removeEventListener("transitionend", handleTransitionEndVisible);
    }


    // EFFECTS:

    useLayoutEffect(() => {
        if(props.helpDisplayed) {
            helpBoxBox.current.addEventListener("transitionend", handleTransitionEndVisible);
        }
        else {
            setOverflow("hidden");
        }
    }, [props.helpDisplayed]);

    useLayoutEffect(() => {
        if(props.btnRef === undefined) {
            return;
        }

        function handleClickAnywhere(e) {
            if (props.btnRef.current && !props.btnRef.current.contains(e.target)) {  
                props.onClose();
            }
        }

        document.addEventListener("click", handleClickAnywhere);
        return () => document.removeEventListener("click", handleClickAnywhere);
    }, [props.onClose, props.btnRef]);


    // RENDER:
    
    return (
        <div className="help_box_box_box">
            <div ref={helpBoxBox} className="help_box_box" style={{ overflow: props.helpDisplayed ? overflow : "hidden", height: props.helpDisplayed ? helpBox.current.scrollHeight : 0}}>
                <div className="help_box" ref={helpBox} >
                    {props.content}
                </div>
            </div>
        </div>
    );
}

// This popup appears in the middle of the screen
export function PopupFixed(props) {
    const scroll = useContext(ScrollContext);

    const helpBox = useRef();
    const contentRef = useRef();

    const [height, setHeight] = useState(0);

    const [performHide, setPerformHide] = useState(false);
    const [contentOverflow, setContentOverflow] = useState(null);

    const displayedRef = useRef();

    const scrollEleRef = useRef();
    const scrollDummyRef = useRef();


    // FUNCTIONS:

    function handleTransitionEnd() {
        setHeight("auto");
        contentRef.current.removeEventListener("transitionend", handleTransitionEnd);
        setContentOverflow("visible");
    }


    // EFFECTS:

    useEffect(() => {
        if(props.helpDisplayed) {
            setHeight(helpBox.current.scrollHeight);

            contentRef.current.addEventListener("transitionend", handleTransitionEnd);

            scroll.setNoScroll(true);
            scroll.setScrollElesSubst([scrollEleRef.current, scrollDummyRef.current]);
        }
        else {
            setContentOverflow(null);
            setPerformHide(true);
            setHeight(helpBox.current.scrollHeight);

            scroll.setNoScroll(false);
            scroll.setScrollElesSubst(null);
        }

        displayedRef.current = props.helpDisplayed;
    }, [props.helpDisplayed]);

    // Do not use useLayoutEffect() as the height won't be set yet
    useEffect(() => {
        if(performHide) {
            setHeight(0);
            setPerformHide(false);
        }
    }, [performHide]);

    useEffect(() => {
        if(props.noAdjustOnContentChange) {
            return;
        }

        if(displayedRef.current) {
            setHeight(helpBox.current.scrollHeight);
        }
    }, [props.content]);
    

    // RENDER:

    return(
        <div ref={scrollEleRef} className={"fixed_popup" + (props.helpDisplayed ? " fixed_popup_visible" : "")}>
            <div className="fixed_popup_scroll_dummy" ref={scrollDummyRef}></div>
            <div ref={contentRef} className={"fixed_popup_content"} style={{height: height, overflow: contentOverflow}}>
                <div ref={helpBox}>
                    {props.content}
                </div>
            </div>
        </div>
    )
}

export function ClosePopup(props) {
    const overlay = useContext(OverlayContext);
    const [lastHelpDisplayed, setLastHelpDisplayed] = useState(props.helpDisplayed);

    let closePopupRef = useRef();

    useLayoutEffect(() => {
        if(lastHelpDisplayed !== props.helpDisplayed) {
            setLastHelpDisplayed(props.helpDisplayed);
            overlay.setOverlay(props.helpDisplayed);

            return () => overlay.setOverlay(false);
        }
    }, [props.helpDisplayed]);

    useLayoutEffect(() => {
        function handleClickAnywhere(e) {
            if (props.btnRef && props.btnRef.current && !props.btnRef.current.contains(e.target) &&
                    !closePopupRef.current.contains(e.target)) {
                props.onClose();
            }
        }

        document.addEventListener("click", handleClickAnywhere);
        return () => document.removeEventListener("click", handleClickAnywhere);
    });

    const content = (
        <div ref={props.boxRef} className="close_popup_box" style={{paddingTop: (props.fixed ? "2rem" : "0.6rem")}}>
            <div ref={closePopupRef} className="close_popup">
                <img className="help_close_icon" src="/common/icon_close.svg" onClick={props.onClose}></img>

                {props.content}
            </div>
        </div>
    );

    return(
        props.fixed ?

        <PopupFixed name={props.name} helpDisplayed={props.helpDisplayed} content={content} onClose={props.onClose}
                noAdjustOnContentChange={props.noAdjustOnContentChange} />
        :
        <Popup helpDisplayed={props.helpDisplayed} content={content} onClose={props.onClose} />
    );
}

export function ErrorPopup(props) {
    const locale = useContext(LocaleContext);

    return(
        <ClosePopup fixed={true} helpDisplayed={props.helpDisplayed}
                onClose={props.onClose}
                btnRef={props.btnRef}
                content={
                    <div className="popup_box_content">
                        <div className="head profile_head">{locale.msgs.ERROR}</div>
                        <div dangerouslySetInnerHTML={{__html: locale.msgs.GENERAL_ERROR_DESCR}}
                                className="text_2 margin_top_low_low"></div>

                        {/*<div className="btn_right">
                            <SquareButton text={locale.msgs.CLOSE} clickable={true} onClick={props.onClose} />
                        </div>*/}
                    </div>
                }
        />
    )
}

export function UploadInput(props) {
    const locale = useContext(LocaleContext);

    const [focussed, setFocussed] = useState(false);
    const [errorText, setErrorText] = useState("");

    const inputRef = useRef();

    function handleSelectClick(e) {
        setErrorText("");

        inputRef.current.value = "";  // Otherwise you can not select the same file again

        if(!props.editable && props.state === UploadInputState.UPLOADED)
        {
            e.stopPropagation(); // Avoid the edit tooltip to appear

            if(props.onDownload) {
                props.onDownload();
            }
            else {
                handleDownload();
            }
        }
        else if(canNewDocumentBeSelected()) {
            inputRef.current.click();
        }
    }

    function handleSelect(e) {
        setErrorText("");

        const fileInput = e.target;

        if(fileInput.files.length === 1) {
            const file = fileInput.files[0];
            handleFile(file);
        }
    }

    function handleFile(file) {
        // Check the filetype:

        let supportedFileendings = ["pdf", "png", "jpeg", "jpg"]; // Default

        if(props.supportedFileendings) {
            supportedFileendings = props.supportedFileendings;
        }

        const splits = file.name.split(".");
        
        if(!supportedFileendings.includes(splits[splits.length - 1].toLowerCase())) {
            let supportedFileendingsStr = "";

            for(let f of supportedFileendings) {
                supportedFileendingsStr += f + ", ";
            }
            supportedFileendingsStr = supportedFileendingsStr.substring(0, supportedFileendingsStr.length - 2);
            
            setErrorText(locale.msgs.SUPPORTED_FILETYPE + ": " + supportedFileendingsStr);
            return;
        }

        // Check the filesize:

        if(file.size > maxFileSizeBytes) {
            setErrorText(locale.msgs.MAX_FILE_SIZE + ": " + (maxFileSizeBytes / 1024 / 1024) + " MB");
            return;
        }

        props.onFileChange(file);
        props.onStateChange(UploadInputState.SELECTED);
    }

    function handleUnselect(e) {
        setErrorText("");

        props.onFileChange(null);
        props.onStateChange(UploadInputState.SELECT);
    }

    function handleDownload() {
        // Create an anchor element  
        const anchor = document.createElement('a');
        // Set the href to the file URL  
        anchor.href = props.url;
            
        // Set the download attribute with a file name  
        // anchor.download = props.filename;

        if(!props.sameTab) {
            // Set target to _blank to open in a new tab
            anchor.target = '_blank';  
        }

        // Append the anchor to the body  
        document.body.appendChild(anchor);  
            
        // Programmatically click the anchor to trigger the download  
        anchor.click();  
            
        // Remove the anchor from the document  
        document.body.removeChild(anchor);  

        // props.onFileChange(null);
        // props.onStateChange(UploadInputState.SELECT);
    }

    function canNewDocumentBeSelected() {
        return props.editable && props.state == UploadInputState.SELECT;
    }

    function handleFocus(e) {
        setFocussed(true);

        if(changed.current) {
            updateErrorText(e.target.value);
        }
    }

    function handleBlur(e) {
        setFocussed(false);

        if(changed.current) {
            updateErrorText(e.target.value);
        }
    }

    function handleDrop(e) {
        e.preventDefault();

        if(props.state !== UploadInputState.SELECT || !props.editable) {
            return;
        }

        setFocussed(false);

        setErrorText("");

        let dt = e.dataTransfer;
        let files = dt.files;

        if(files.length === 1) {
            handleFile(files[0]);
        }
    }

    function handleDragOver(e) {
        e.preventDefault();
    }

    function handleDragEnter(e) {
        e.preventDefault();

        if(props.state !== UploadInputState.SELECT || !props.editable) {
            return;
        }

        setFocussed(true);
    }

    function handleDragLeave(e) {
        e.preventDefault();
        
        if(props.state !== UploadInputState.SELECT || !props.editable) {
            return;
        }

        setFocussed(false);
    }


    // EFFECTS:

    useLayoutEffect(() => {
        if(!props.editable) {
            setErrorText("");
        }
    }, [props.editable]);

    useLayoutEffect(() => {
        function handleClickAnywhere(e) {
            setErrorText(""); 
        }

        document.addEventListener("click", handleClickAnywhere);
        return () => document.removeEventListener("click", handleClickAnywhere);
    }, []);


    // RENDER:

    let text = "";
    let textClass = "input_name upload_input_name";
    let textClassInputName = "input_name";

    if(props.state == UploadInputState.UPLOADING) {
        text = locale.msgs.UPLOAD_IN_PROGRESS;
        textClass += " input_name_black";
        textClassInputName += " input_name_top";
    }
    else if(props.state == UploadInputState.DELETING) {
        text = locale.msgs.DELETE_IN_PROGRESS;
        textClass += " input_name_black";
        textClassInputName += " input_name_top";
    }
    else if(props.state == UploadInputState.UPLOADED) {
        if(props.editable) {
            text = props.filename;
            textClass += " input_name_black";
            textClassInputName += " input_name_top";
        }
        else {
            text = props.filename;
            textClass += " input_name_black input_name_uploaded";
        }
    }
    else if(props.state == UploadInputState.SELECTED) {
        text = props.filename;
        textClass += " input_name_black";
        textClassInputName += " input_name_top";
    }

    return(
        <div>
            <div className="upload_input_box_box_box" >

                { props.removeBtnPresent ?
                    <div className="upload_input_remove_btn">
                        <RemoveButton onClick={props.onRemoveBtnClick} visible={props.removable} />
                    </div>
                :
                    null
                }

                <div className="upload_input_box_box" >
                    { !props.editable && props.state === UploadInputState.UPLOADED ?
                        <div key="upload_input_name_top_high" className="input_name input_name_top_high">{props.name}</div>
                    :
                        null
                    }

                    <div className={"input_box upload_input_box" + (focussed ? " input_box_focus" : "")} onClick={handleSelectClick}>

                        <div className={"input input_file" + (canNewDocumentBeSelected() || (!props.editable && props.state === UploadInputState.UPLOADED) ? " input_file_clickable" : "") + (!props.editable && props.state == UploadInputState.UPLOADED ? " input_file_uploaded" : "")}
                                onDrop={handleDrop} onDragOver={handleDragOver} onDragEnter={handleDragEnter} onDragLeave={handleDragLeave}></div>

                        <input ref={inputRef} type="file" className="file_input" accept=".jpg, .jpeg, .png, .pdf" onChange={handleSelect}
                                onBlur={handleBlur} onFocus={handleFocus}
                        ></input>

                        <div className={textClass}>{text}</div>

                        { props.editable || (!props.editable && props.state === UploadInputState.SELECT) ?
                            <div key="upload_input_name_top" className={textClassInputName}>{props.name}</div>
                        :
                            null
                        }

                        {
                            props.editable && props.state == UploadInputState.SELECT ?

                            <div className="upload_btn upload_btn_not_clickable">
                                <img className="upload_btn_img" src="/common/icon_upload.svg" />
                            </div>

                            : null
                        }

                        {
                            props.editable && (props.state == UploadInputState.SELECTED || props.state == UploadInputState.UPLOADED) ?

                            <div className="upload_btn" onClick={handleUnselect}>
                                <img className="upload_btn_img" src="/common/icon_close.svg" />
                            </div>

                            : null
                        }

                        {
                            !props.editable && props.state == UploadInputState.UPLOADED ?

                            <div className="upload_btn" onClick={() => {}}>
                                <img className="upload_btn_img" src="/common/icon_download.svg" />
                            </div>

                            : null
                        }
                        
                        {
                            props.editable && (props.state == UploadInputState.UPLOADING || props.state == UploadInputState.DELETING) ?
                            
                            <div className="upload_progress text_2">
                                {props.uploadProgress}%
                            </div>

                            : null
                        }
                    </div>

                </div>
            </div>

            { (props.errorMsg && props.errorMsg !== "") || errorText != "" ? <div className="text_error_small">{props.errorMsg + errorText}</div> : null}
        </div>
    );
}

export const LeavePrompt = ({}) => {
    useLayoutEffect(() => {
        function handleBeforeUnload(e) {
            e.preventDefault();
            e.returnValue = "";
            return "";
        }

        window.addEventListener("beforeunload", handleBeforeUnload /*, { capture: true } */);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, []);

    return null;
};

export const AddButton = ({onClick, noMargin}) => {
    return(
        <button className={"add_btn_box" + (noMargin ? " add_btn_box_no_margin" : "")} onClick={onClick}>
            <img className="add_btn" src="/common/icon_add.svg"></img>
        </button>
    );
}

export const AddButton2 = ({text, onClick, editable}) => {
    return(
        <div className={"add_btn_2_box noselect" + (!editable ? " add_btn_2_box_no_edit" : "")} onClick={onClick}>
            <div className="add_btn_2_box_abs" style={{visibility: editable ? "hidden" : "visible"}}/>
            <img src="/common/icon_add_2.svg"/>
            <div className="add_btn_2_box_text">{text}</div>
        </div>
    );
}



export const RemoveButton = ({onClick, visible}) => {
    return(
        <img className="lang_remove_btn" src="/common/icon_delete.svg" onClick={onClick} style={ !visible ? {"visibility": "hidden"} : {}}/>
    );
}

export const Loading = ({padding, fixed, vhtop, management, userLocation}) => {
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);

    // <div className={"text_2 margin_top_low_low error" + (padding ? " side_padding" : "")}>{locale.msgs.LOADING}</div>

    return(
        <div className={"loading_img_box_box" + (fixed ? " loading_img_box_box_fixed" : "") + (vhtop ? " loading_img_box_box_vhtop" : "")}>
            <div className="loading_img_box">
                <img className="loading_img loading_img_management" src={management ? getManagementLogoPath(login ? login.userLocation : userLocation) : "/customer/Logo_plain_2.svg"} />
            </div>
        </div>
    );
}

export const ErrorComp = ({text, noTopMargin}) => {
    const locale = useContext(LocaleContext);

    return(
        <div className={"text_2 error" + (noTopMargin ? "" : " margin_top_low_low") }>{text}</div>
    );
}

export const HeadWithBackBtn = ({showBtn, onClick, onProfileClick, text, smallText, user, menuIcon, menuBtnRef, customDescr}) => {
    const locale = useContext(LocaleContext);
    const navigateLock = useContext(NavigateLockContext);

    return(
        <div className="head_with_back_btn">
            { showBtn ?
                <div className="head_with_back_btn_btn">
                    <BackButton onClick={(e) => navigateLock.handleLockProtectedClick(e, onClick)} />
                </div>
            :
                null
            }
            
            <div className="head_with_back_btn_text_box">
                <div className={smallText ? "head_small" : "head"}>
                    {text}
                </div>

                { user || customDescr ?
                    <div className="head_with_back_btn_descr text_2">
                        { customDescr ?
                            customDescr
                        :
                            [
                                getUserStr(Object.assign(user.care_data ? {first_name: user.care_data.first_name, last_name: user.care_data.last_name} : {}, user), locale),
                                <br/>,
                                user.user_type === UserType.NANNY && user.birth_date ? (new Date(user.birth_date).toLocaleString(undefined, {year: "numeric", month: "2-digit", day: "2-digit"})) : ""
                            ]
                        }
                    </div>
                :
                    null
                }

            </div>

            { user ?
                <div className="head_with_back_btn_profile" onClick={(e) => navigateLock.handleLockProtectedClick(e, onProfileClick)}>
                    <img ref={menuBtnRef} src={menuIcon ? "/common/icon_menu_2.svg" : "/management/icon_contact.svg"}/>
                </div>
            :
                null
            }
        </div>
    );
}

export const FilterBtn = ({onClick, selected}) => {
    const locale = useContext(LocaleContext);

    return(
        <div className={"filter_btn noselect" + (selected ? " filter_btn_selected" : "")} onClick={onClick}>
            <img className="filter_btn_img" src="/common/icon_filter.svg"></img>
            <div className="filter_btn_text">{locale.msgs.FILTER}</div>
        </div>
    );
}

export const EditBtn = ({onClick, editable}) => {
    return(
        <div className="edit_btn_box" onClick={onClick}>
            <img className="edit_icon" style={{visibility: editable ? "hidden" : "visible"}}
                    src={/*editable ? "/common/icon_edit_light.svg" : */"/common/icon_edit.svg"}></img>
        </div>
    );
}

export const SaveCancelBox = ({editable, savable, saving, saved, notSaved, onSaveClick, onCancelClick, saveBtnText, smallPad, vertical,
                               lockNavigation}) => {
    const locale = useContext(LocaleContext);
    const scroll = useContext(ScrollContext);
    const navigateLock = useContext(NavigateLockContext);

    const saveBtnRef = useRef();

    useLayoutEffect(() => {
        if(lockNavigation && navigateLock.lockAnimationRunning) {
            const rect = saveBtnRef.current.getBoundingClientRect();
            scroll.scrollTo(rect.top, rect.bottom);
        }
    }, [navigateLock.lockAnimationRunning]);

    return(
        <div className={"save_cancel_box" + (editable ? " save_cancel_box_edit" : "") + (vertical ? " save_cancel_box_vertical" : "")}>
            {
                editable ?
                    <div ref={saveBtnRef} className={ lockNavigation && navigateLock.lockAnimationRunning ? "shake_animation" : ""} onAnimationEnd={() => navigateLock.setLockAnimationRunning(false)}>
                        <SquareButton text={locale.msgs.CANCEL} white={true} clickable={true} onClick={onCancelClick} smallPad={smallPad}/>
                    </div>
                : null
            }

            <div className={ lockNavigation && navigateLock.lockAnimationRunning ? "shake_animation" : ""} onAnimationEnd={() => navigateLock.setLockAnimationRunning(false)}>
                <SaveButton text={saveBtnText ? saveBtnText : locale.msgs.SAVE} clickable={savable} saving={saving} saved={saved}
                        notSaved={notSaved} smallPad={smallPad}
                        onClick={onSaveClick}/>
            </div>
        </div>
    );
}

export const AvailabilityByPhoneInput = ({editable, careData, onCareDataChange, onScroll}) => {
    const locale = useContext(LocaleContext);

    const [telephoneAvailabilityTransList, telephoneAvailabilityTransListInverse] = get_translation_objects("telephone_availability", AvailabilityByPhone, locale);

    return (
        <div className="availability_by_phone_input">
            {!editable ?
                <TextInput minimal={true} readOnly={!editable} text={locale.msgs.TELEPHONE_AVAILABILITY_2}
                        value={careData["availability_by_phone"] === AvailabilityByPhone.ALWAYS ?
                            telephoneAvailabilityTransList[AvailabilityByPhone.ALWAYS]
                            : careData["specific_availability_by_phone"]
                        }
                        onChange={() => {}} />
            :
                <DropdownMenu minimal={true} readOnly={!editable} text={locale.msgs.TELEPHONE_AVAILABILITY_2} options={Object.values(telephoneAvailabilityTransList)}
                    value={telephoneAvailabilityTransList[careData["availability_by_phone"]]}
                    onValueChange={(value) => onCareDataChange({...careData, "availability_by_phone": telephoneAvailabilityTransListInverse[value]})}
                    onScroll={onScroll} />
            }

            { editable && careData["availability_by_phone"] === AvailabilityByPhone.SPECIFIC ?

                <div className="profile_data_specific_tel_availability_box">
                    <TextInput minimal={true} readOnly={!editable} text={locale.msgs.TELEPHONE_AVAILABILITY_SPECIFIC_2}
                            value={careData["specific_availability_by_phone"] === AvailabilityByPhone.ALWAYS ?
                                AvailabilityByPhone.ALWAYS
                                : careData["specific_availability_by_phone"]
                            }
                            onChange={(value) => onCareDataChange({...careData, "specific_availability_by_phone": value})}
                            checker={(value) => validateSpecificAvailabilityByPhone(value)}
                            errorText={locale.msgs.INVALID_VALUE}
                            maxLength={maxSpecificAvailabilityByPhoneLength} />
                </div>
            :
                null
            }
        
        </div>
        
    );
}

export function AgeOfChildrenFamSelect(props) {
    const locale = useContext(LocaleContext);

    function handleAddClick() {
        const newArr = [...props.ageOfChildrenFam];
        newArr.push("");
        props.onAgeOfChildrenFamChange(newArr);
    }

    function handleRemoveClick() {
        const newArr = [...props.ageOfChildrenFam];
        newArr.pop();
        props.onAgeOfChildrenFamChange(newArr);
    }

    const maxChildren = 6;
    const extraChidlrenLimit = 3;

    const dropdowns = [];

    const ageMap = {
        "": "",
        "1": getAgeStr(1, locale)
    };

    const ageMapInverse = {
        [ageMap["1"]]: "1",
        "": ""
    };

    for(let i = 2; i <= 17; i++) {
        ageMap[i] = getAgeStr(i, locale);
        ageMapInverse[ageMap[i]] = i.toString();
    }

    for(let i = 0; i < props.ageOfChildrenFam.length; i++) {
        let dropdownEle =
                <DropdownMenu minimal={props.minimal} readOnly={!props.editable} text={locale.msgs.AGE_OF_CHILD.replace("${{num}}", i + 1)}
                        options={Object.values(ageMap)}
                        value={ageMap[props.ageOfChildrenFam[i]]}
                        onValueChange={(value) => {
                            const newArr = [...props.ageOfChildrenFam];
                            newArr[i] = ageMapInverse[value];
                            props.onAgeOfChildrenFamChange(newArr);
                        }}
                        onScroll={props.onScroll}
                        showPlaceholderIfNotEmpty={props.minimal ? true : false}/>;

        if(props.points && i === 0) {
            dropdownEle =
                    <MatchInfoWrapper points={props.points}>
                        {dropdownEle}
                    </MatchInfoWrapper>;
        }

        dropdowns.push(
            <div className="age_of_children_fam_hori_box">
                {dropdownEle}

                { props.editable && (props.ageOfChildrenFam.length > extraChidlrenLimit || (props.management && props.ageOfChildrenFam.length > 1)) ?
                    <div className="right_remove_btn_box">
                        <RemoveButton onClick={handleRemoveClick} visible={i >= extraChidlrenLimit || (props.management && i >= 1)}/>
                    </div>
                :
                    null
                }
                
            </div>
        );
    }

    return (
        <div className={"age_of_children_fam_select" + (props.minimal ? " input_minimal_gap" : "")}>
            {dropdowns}

            { props.editable && (props.ageOfChildrenFam.length >= extraChidlrenLimit || props.management) && props.ageOfChildrenFam.length < maxChildren?
                <div className="age_of_children_fam_select_add_btn">
                    <AddButton onClick={handleAddClick} noMargin={true} />
                </div>
            :
                null
            }
        </div>
    );
}

export const MenuDropdown = ({menuBtnRef, menuDisplayed, setMenuDisplayed, elements}) => {
    return (
        <div className="menu_dropdown">
            <Popup helpDisplayed={menuDisplayed} btnRef={menuBtnRef} onClose={() => {setMenuDisplayed(false)}} content={
                <div className="profile_menu_content">
                    <div className="profile_menu_inner_content">
                        {elements}
                    </div>
                </div>
            } />
        </div>
    );
}

export const DeactivateAccountPopup = ({confirmDisplayed, setConfirmDisplayed, onAccountDeactivated, onAccountReactivated, management,
        userId, userActive}) => {
    const locale = useContext(LocaleContext);
    const overlay = useContext(OverlayContext);
    const state = useContext(StateContext);

    const [loadState, setLoadState] = useState(LoadState.NONE);

    const [reasonForDeactivation, setReasonForDeactivation] = useState("");

    function handleConfirmClick() {
        if(userActive) {
            deactivateUser();
        }
        else {
            reactiveUser();
        }
    }

    function deactivateUser() {
        try {
            let url = "/user/delete_account";
            let obj = {};

            if(management) {
                url = "/user/management/deactivate_user";
                obj = {"user_id": userId, "reason": reasonForDeactivation};
            }

            postWithCsrf(url, JSON.stringify(obj), state).then(response => {
                if(response.ok) {
                    if(management) {
                        return response.json();
                    }
                    else {
                        setLoadState(LoadState.LOAD_SUCCESS);

                        setConfirmDisplayed(false);
                        overlay.setOverlay(false);

                        if(onAccountDeactivated) {
                            onAccountDeactivated();
                        }
                    }
                }
                else {
                    throw new Error("Response code: " + response.status);
                }
            }).then(json => {
                setLoadState(LoadState.LOAD_SUCCESS);

                setConfirmDisplayed(false);
                overlay.setOverlay(false);

                if(onAccountDeactivated) {
                    onAccountDeactivated(json);
                }
            }).catch(error => {
                setLoadState(LoadState.LOAD_ERROR);
                console.log(error);
            });

            // Calling setLoadState() after postWithCsrf() as it could throw an exception
            setLoadState(LoadState.LOADING);
        }
        catch(e) {
            console.log(e);
        }
    }

    function reactiveUser() {
        // Only for management

        try {
            let url = "/user/management/reactivate_user";
            let obj = {"user_id": userId};

            postWithCsrf(url, JSON.stringify(obj), state).then(response => {
                if(response.ok) {
                    return response.json();
                }
                else {
                    throw new Error("Response code: " + response.status);
                }
            }).then(json => {
                setLoadState(LoadState.LOAD_SUCCESS);

                setConfirmDisplayed(false);
                overlay.setOverlay(false);

                if(onAccountReactivated) {
                    onAccountReactivated(json);
                }
            }).catch(error => {
                setLoadState(LoadState.LOAD_ERROR);
                console.log(error);
            });

            // Calling setLoadState() after postWithCsrf() as it could throw an exception
            setLoadState(LoadState.LOADING);
        }
        catch(e) {
            console.log(e);
        }
    }


    useEffect(() => {
        setLoadState(LoadState.NONE);
    }, [confirmDisplayed]);

    return (
        <ClosePopup name="deactivate_account" fixed={true} helpDisplayed={confirmDisplayed} onClose={() => setConfirmDisplayed(false)}
                content={
                    <div className="delete_account_popup">
                        <div className="head delete_account_popup_head">{management ? (userActive ? locale.msgs.DEACTIVATE_ACCOUNT : locale.msgs.REACTIVATE_ACCOUNT) : locale.msgs.DELETE_ACCOUNT}</div>
                        <div className="text_2 margin_top_low_low">{management ? (userActive ? locale.msgs.DEACTIVATE_ACCOUNT_CONFIRM : locale.msgs.REACTIVATE_ACCOUNT_CONFIRM) : locale.msgs.DELETE_ACCOUNT_CONFIRM}</div>

                        { userActive && management ? [
                            <div className="text_light_2 delete_account_reason_text">{locale.msgs.REASON_FOR_DEACTIVATION}</div>,

                            <TextInputMultiline text={locale.msgs.REASON_FOR_DEACTIVATION} value={reasonForDeactivation}
                                    onChange={(value) => setReasonForDeactivation(value)}
                                    showPlaceholderIfNotEmpty={false} height="15rem"
                            />
                        ] :
                            null
                        }

                        <div className="delete_account_btn_right">
                            <LoadButton text={userActive ? (management ? locale.msgs.DEACTIVATE : locale.msgs.DELETE_ACCOUNT) : locale.msgs.REACTIVATE} clickable={true} onClick={handleConfirmClick}
                                    saving={loadState === LoadState.LOADING}
                                    notSaved={loadState === LoadState.LOAD_ERROR}
                                    errText={locale.msgs.ERROR} />
                        </div>
                    </div>
                }
        />
    );
}

export const DeleteAccountPopup = ({confirmDisplayed, setConfirmDisplayed, onAccountDeleted, management, userId, newsletterSubscribed}) => {
    const locale = useContext(LocaleContext);
    const overlay = useContext(OverlayContext);
    const state = useContext(StateContext);

    const [loadState, setLoadState] = useState(LoadState.NONE);

    const [reasonForDeletion, setReasonForDeletion] = useState("");

    const [matchError, setMatchError] = useState(false);
    const [schedMailsError, setSchedMailsError] = useState(false);
    const [schedMailsCount, setSchedMailsCount] = useState(0);
    const [keepNewsletter, setKeepNewsletter] = useState(true);


    function handleConfirmClick() {
        deleteUser();
    }

    function deleteUser() {
        try {
            let url = "/user/delete_account";
            let obj = {};

            if(management) {
                url = "/user/management/delete_user";
                obj = {"user_id": userId, "reason": reasonForDeletion, "force_match": matchError,
                        "force_sched_mails": schedMailsError, "keep_newsletter": keepNewsletter && newsletterSubscribed};
            }

            postWithCsrf(url, JSON.stringify(obj), state).then(response => {
                if(response.ok) {
                    setLoadState(LoadState.LOAD_SUCCESS);

                    setConfirmDisplayed(false);
                    overlay.setOverlay(false);

                    if(onAccountDeleted) {
                        onAccountDeleted();
                    }
                }
                else {
                    if(response.status === 525) {
                        return response.json().then(json => {
                            setLoadState(LoadState.LOAD_SUCCESS);
                            setMatchError(true);
                        });
                    }
                    else if(response.status === 526) {
                        return response.json().then(json => {
                            setLoadState(LoadState.LOAD_SUCCESS);
                            setSchedMailsError(true);
                            setSchedMailsCount(json.sched_mails_count);
                        });
                    }
                    else {
                        throw new Error("Response code: " + response.status);
                    }
                }
            }).catch(error => {
                setLoadState(LoadState.LOAD_ERROR);
                console.log(error);
            });

            // Calling setLoadState() after postWithCsrf() as it could throw an exception
            setLoadState(LoadState.LOADING);
        }
        catch(e) {
            console.log(e);
        }
    }


    useEffect(() => {
        setLoadState(LoadState.NONE);
        setMatchError(false);
        setSchedMailsError(false);
    }, [confirmDisplayed]);

    return (
        <ClosePopup name="delete_account" fixed={true} helpDisplayed={confirmDisplayed} onClose={() => setConfirmDisplayed(false)}
                content={
                    <div className="delete_account_popup">
                        <div className="head delete_account_popup_head">{locale.msgs.DELETE_ACCOUNT}</div>

                        { !matchError && !schedMailsError ? [
                            <div className="text_2 margin_top_low_low">{locale.msgs.DELETE_ACCOUNT_CONFIRM}</div>,

                            management ? [
                                <div className="text_light_2 delete_account_reason_text">{locale.msgs.REASON_FOR_DELETION}</div>,

                                <TextInputMultiline text={locale.msgs.REASON_FOR_DELETION} value={reasonForDeletion}
                                        onChange={(value) => setReasonForDeletion(value)}
                                        showPlaceholderIfNotEmpty={false} height="15rem"
                                />,

                                newsletterSubscribed ?
                                    <div className="delete_account_checkbox_box">
                                        <RadioCheckButton type="checkbox" tiny={true} id={"delete_account_checkbox_" + userId}
                                                name={"delete_account_checkbox_" + userId}
                                                text={locale.msgs.KEEP_NEWSLETTER_DESCR} checked={keepNewsletter} 
                                                onChange={(e) => setKeepNewsletter(e.target.checked)}
                                                readOnly={false}
                                                breakLine={true}
                                        />
                                    </div>
                                :
                                    null
                            ] :
                                null
                        ] : matchError ? [
                            <div className="text_2 margin_top_low_low">{locale.msgs.DELETE_ACCOUNT_CONFIRM_HAS_MATCH_WARNING}</div>,
                            <div className="text_2 margin_top_low_low">{locale.msgs.DELETE_ACCOUNT_CONFIRM}</div>
                        ] : schedMailsError ? [
                            <div className="text_2 margin_top_low_low">{locale.msgs.DELETE_ACCOUNT_CONFIRM_HAS_SCHED_MAILS_WARNING.replace("${{num_mails}}", schedMailsCount)}</div>,
                            <div className="text_2 margin_top_low_low">{locale.msgs.DELETE_ACCOUNT_CONFIRM}</div>
                        ] : null}

                        <div className="delete_account_btn_right">
                            <LoadButton text={locale.msgs.DELETE} clickable={true} onClick={handleConfirmClick}
                                    saving={loadState === LoadState.LOADING}
                                    notSaved={loadState === LoadState.LOAD_ERROR}
                                    errText={locale.msgs.ERROR} />
                        </div>
                    </div>
                }
        />
    );
}
  
export function NavigateSmart({to, ...props}) {  
    const location = useLocation();
    const toWithLang = createNavigateSmartUrl(location, to);

    // console.log("navigate smart: " + toWithLang);

    return <Navigate to={toWithLang} {...props} />;
}  

export const SwitchButton = ({on, onClick, grayedOut}) => {

    return(
        <div className={"switch_btn_box" + (on ? " switch_btn_box_on" : " switch_btn_box_off")} onClick={onClick}>
            { grayedOut ? <div className="switch_btn_box_overlay" /> : null }

            <div className="switch_btn_circle"></div>
        </div>
    );
}

export function LinkSmart(props) {
    const locale = useContext(LocaleContext);

    let {to, ...otherProps} = props;
    
    const hasQuery = to.includes('?');

    if(locale.locale !== "de") {
        to = `${to}${hasQuery ? '&' : '?'}lang=${locale.locale}`;
    }

    return(
        <Link {...otherProps} to={to}/>
    );
} 

export const SafeEditBtn = ({safeEdit, onClick, editable, showTooltip}) => {
    const locale = useContext(LocaleContext);

    const [editBtnTooltipWidth, setEditBtnTooltipWidth] = useState(0);


    // EFFECT:

    useLayoutEffect(() => {
        const viewportEle = document.getElementById("app");

        const boxRect = safeEdit.editBtnRef.current.getBoundingClientRect();
        const viewportRect = viewportEle.getBoundingClientRect();

        const marginRight = viewportRect.right - boxRect.right;
        setEditBtnTooltipWidth(viewportEle.clientWidth - (marginRight * 2));
    });


    // RENDER:

    return (
        <div ref={safeEdit.editBtnRef} className="safe_edit_btn">
                {!editable && safeEdit.displayEditTooltip && showTooltip?
                    <div className="edit_btn_tooltip"style={{width: editBtnTooltipWidth}}>
                        <div className="edit_btn_tooltip_arrow"></div>
                        {locale.msgs.EDIT_BTN_TOOLTIP}
                    </div>
                :
                    null
                }

            <div className={"edit_btn_shake_box" + (safeEdit.shakingEditBtn ? " shake_animation" : "")} onAnimationEnd={() => safeEdit.setShakingEditBtn(false)}>
                <EditBtn onClick={onClick} editable={editable} />
            </div>
        </div>
    );
}

export const Tooltip = ({text, visible, boxRef, onScroll}) => {
    const scroll = useContext(ScrollContext);

    const [tooltipMaxWidth, setTooltipMaxWidth] = useState(0);
    const [left, setLeft] = useState(true);
    const [wrapText, setWrapText] = useState(false);
    const [portalRect, setPortalRect] = useState(0);

    if(!boxRef) {
        boxRef = useRef();
    }
    
    const textRef = useRef();
    const tooltipRef = useRef();
    const scrollEleRef = useRef();


    // EFFECT:

    useLayoutEffect(() => {
        function perform() {
            const viewportEle = document.getElementById("app");

            const boxRect = boxRef.current.getBoundingClientRect();
            const viewportRect = viewportEle.getBoundingClientRect();

            const boxCenterX = boxRect.left + (boxRect.right - boxRect.left) / 2;
            const viewportCenterX = viewportRect.left + (viewportRect.right - viewportRect.left) / 2;
            setLeft(boxCenterX < viewportCenterX);

            setTooltipMaxWidth((viewportRect.right - viewportRect.left) / 2);

            if(textRef.current && tooltipRef.current) {
                const textRect = textRef.current.getBoundingClientRect();
                const tooltipRect = tooltipRef.current.getBoundingClientRect();

                const textWidth = textRect.right - textRect.left;
                const tooltipWidth = tooltipRect.right - tooltipRect.left;

                if(textWidth > tooltipWidth)
                {
                    setWrapText(true);
                }
            }


            setPortalRect({
                x: boxRect.left,
                y: boxRect.top,
                width: boxRect.right - boxRect.left,
                height: boxRect.bottom - boxRect.top
            });
        }

        perform();

        window.addEventListener("resize", perform);
        return () => {
            window.removeEventListener("resize", perform);
        };
    }, [visible]);

    useEffect(() => {
        // We want to remove the tooltip on scroll as mouse events (e.g. mouseout) often do not trigger correctly on scroll
        function onGlobalScroll() {
            onScroll();
        }

        scrollEleRef.current = scroll.getScrollEle();  // Saving the scroll element to be able to call removeEventListener() on that element (getScrollEle() might return another one)
        scrollEleRef.current.addEventListener("scroll", onGlobalScroll);

        return (() => {
            scrollEleRef.current.removeEventListener("scroll", onGlobalScroll);
        });
    }, []);


    // RENDER:

    const tooltipPortalEle = document.getElementById("tooltip_portal");

    return (
        <div ref={boxRef} className="tooltip_box">
            { visible ?
                createPortal(
                    <div className="tooltip_portal_content" style={{left: portalRect.x, top: portalRect.y, width: portalRect.width, height: portalRect.height}}>
                        <div ref={tooltipRef} className={"tooltip" + (left ? " tooltip_left" : " tooltip_right")} style={{maxWidth: tooltipMaxWidth}}>
                            <div className={"tooltip_arrow" + (left ? " tooltip_arrow_left" : " tooltip_arrow_right")}></div>
                            {text}
                        </div>
                    </div>
                , tooltipPortalEle)
            :
                null
            }
        </div>
    );
}

export const TimedTooltip = ({text}) => {
    const [visible, setVisible] = useState(false);

    const tooltipRef = useRef();
    const timeoutRef = useRef(null);

    const pressedRef = useRef(false);


    // EFFECTS:

    useEffect(() => {
        function onMouseOver() {
            onMouseOut(); // Never allow more than one timeout

            timeoutRef.current = setTimeout(() => {
                setVisible(true);
            }, tooltipDelayMs);
        }

        function onMouseOut() {
            if(timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }

            setVisible(false);
        }

        function onTouchStart(e) {
            onMouseOut(); // Never allow more than one timeout

            timeoutRef.current = setTimeout(() => {
                setVisible(true);
                pressedRef.current = true;
                e.preventDefault();  // Avoid the click event from being fired
            }, tooltipDelayMs);
        }

        function onTouchEnd(e) {
            onMouseOut();

            if(pressedRef.current) {
                e.preventDefault();  // Avoid the click event from being fired
            }

            pressedRef.current = false;
        }


        tooltipRef.current.addEventListener("mouseover", onMouseOver);
        tooltipRef.current.addEventListener("mouseout", onMouseOut);

        tooltipRef.current.addEventListener("touchstart", onTouchStart);
        tooltipRef.current.addEventListener("touchend", onTouchEnd);

        return (() => {
            if(tooltipRef.current) {
                tooltipRef.current.removeEventListener("mouseover", onMouseOver);
                tooltipRef.current.removeEventListener("mouseout", onMouseOut);

                tooltipRef.current.removeEventListener("touchstart", onTouchStart);
                tooltipRef.current.removeEventListener("touchend", onTouchEnd);
            }
        });
    }, []);


    // RENDER:

    return (
        <Tooltip boxRef={tooltipRef} text={text} visible={visible} onScroll={() => setVisible(false)} />
    );
}
